/* Carousel */
class BUTCarousel extends BUTCustomComponent {
  constructor() {
    super();

    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");
    this.pagination = this.$(".js-carousel-pagination-dots");
    this.pagination_items = this.pagination?.querySelectorAll(
      ".js-carousel-pagination-dot"
    );

    this.scrollbarThumb = this.$(".js-scrollbar-thumb");
    this.scrollbarTrack = this.$(".js-scrollbar-track");
    this.desktopThumbItemCount = parseInt(
      this.scrollbarTrack?.dataset.thumbDesk
    );
    this.tabletThumbItemCount = parseInt(
      this.scrollbarTrack?.dataset.thumbTablet
    );
    this.mobileThumbItemCount = parseInt(
      this.scrollbarTrack?.dataset.thumbMobile
    );
    this.totalItems = parseInt(this.scrollbarTrack?.dataset.thumbTotal);
  }

  connectedCallback() {
    this.init();
    this.bindEventHandlers();
  }

  init() {
    if (this.dataset.enable == "false" && this.dataset.enableMobile == "false")
      return;
    this.itemsToShow = Array.from(this.carousels).filter(
      (element) => element.clientWidth > 0
    );
    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }
    this.gutter =
      parseFloat(
        window
          .getComputedStyle(this.itemsToShow[1], null)
          .getPropertyValue("padding-left")
      ) +
      parseFloat(
        window
          .getComputedStyle(this.itemsToShow[1], null)
          .getPropertyValue("padding-right")
      );
    this.itemOffset =
      this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor(
      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) /
        this.itemOffset
    );

    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
    this.updateCarousel();
  }

  pauseAllVideo() {
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='youtube']"
    ).forEach((video) => {
      video.player?.pauseVideo();
    });
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='vimeo'])"
    ).forEach((video) => {
      video.playerVimeo?.pause();
    });
    BUTHelper.qsa(".js-media-item-video").forEach((video) => {
      video.pause();
    });
  }

  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML = this.currentPage;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (
      this.isItemVisible(this.itemsToShow[0]) &&
      this.container.scrollLeft === 0
    ) {
      this.prevBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement?.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement?.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }

    this.updatePagination();
    this.pauseAllVideo();
    this.updateScrollIndicator();
  }

  updatePagination() {
    if (this.pagination) {
      let item = this.pagination.querySelector(
        `li[data-dot-index="${this.currentPage}"]`
      );
      if (item) {
        this.pagination_items.forEach((el) => el.classList.remove("is-active"));
        item.classList.add("is-active");
      }
    }
  }

  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
    } else {
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  isItemVisible(element, offset = 0) {
    if (typeof element == "undefined") return false;

    const carouselSpecial = this.classList.contains("carousel--special");
    let lastVisibleItem;
    let paddingContainer;

    if (carouselSpecial) {
      lastVisibleItem =
        this.container.clientWidth +
        this.container.scrollLeft -
        offset -
        Math.abs(this.container.offsetLeft) +
        1;
      paddingContainer = 0;
    } else {
      lastVisibleItem =
        this.container.clientWidth + this.container.scrollLeft - offset;
      paddingContainer = parseInt(getComputedStyle(this.container).paddingLeft);
    }

    return (
      Math.floor(
        element.getBoundingClientRect().width +
          paddingContainer +
          element.offsetLeft
      ) <= Math.round(lastVisibleItem) &&
      element.offsetLeft >= this.container.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    let step = event.currentTarget.dataset.stepMb;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 459px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (
      this.container.scrollLeft == 0 ||
      this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
    ) {
      gutter = this.gutter;
    }
    this.itemScrollPosition =
      event.currentTarget.name === "next"
        ? this.container.scrollLeft - gutter + step * this.itemOffset
        : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }

  updateScrollIndicator() {
    if (!this.scrollbarTrack) return;

    this.maxScroll = this.container.scrollWidth - this.container.clientWidth;
    this.scrollPercent = (this.container.scrollLeft / this.maxScroll) * 100;

    this.thumbPercentDesk = this.calculateThumbPercent(
      this.desktopThumbItemCount
    );
    this.thumbPercentTablet = this.calculateThumbPercent(
      this.tabletThumbItemCount
    );
    this.thumbPercentMobile = this.calculateThumbPercent(
      this.mobileThumbItemCount
    );

    this.scrollbarTrack.style.setProperty(
      "--width-thumb-desktop",
      `${this.thumbPercentDesk}%`
    );
    this.scrollbarTrack.style.setProperty(
      "--width-thumb-tablet",
      `${this.thumbPercentTablet}%`
    );
    this.scrollbarTrack.style.setProperty(
      "--width-thumb-mobile",
      `${this.thumbPercentMobile}%`
    );
  }

  calculateThumbPercent(dataThumb) {
    return (
      ((dataThumb +
        (this.scrollPercent / 100) * (this.totalItems - dataThumb)) *
        100) /
      this.totalItems
    );
  }

  bindEventHandlers() {
    if (this.dataset.enable == "false" && this.dataset.enableMobile == "false")
      return;
    const resizeObserver = new ResizeObserver((entries) => this.init());

    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    this.prevBtnElement?.addEventListener("click", (e) => {
      this.updateScrollIndicator();
      this.onButtonClick(e);
    });
    this.nextBtnElement?.addEventListener("click", (e) => {
      this.updateScrollIndicator();
      this.onButtonClick(e);
    });
    this.container.addEventListener("scroll", () => {
      this.updateScrollIndicator();
      BUTHelper.debounce(this.updateCarousel(), 100);
    });
  }
}
customElements.define("but-carousel", BUTCarousel);

/* Drawer */
class BUTCoreDrawer extends BUTCustomComponent {
  constructor() {
    super();
    this.drawerWrapperElement = this.$(".js-drawer-wrapper");
    this.drawerOverlayElement = this.$(".js-drawer-overlay");
    this.closeBtnElement = this.$$(".js-drawer-btn-close");
    this.opener = null;
    this.bodyElement = document.body;
    this.isMobileMenuDrawer = this.closest("but-menu-drwer");
    this.bindEventHandlers();
    this.scrollElement = this.$(".js-scroll-element");
    this.containerOverflowElement = this.$(".js-container-overflow");
  }

  bindEventHandlers() {
    this.drawerOverlayElement.addEventListener(
      "click",
      this.closeDrawer.bind(this)
    );

    this.closeBtnElement.forEach((btn) => {
      btn.addEventListener("click", this.closeDrawer.bind(this));
      window.addEventListener("load", () => {
        this.removeAttribute("hidden");
      });
    });
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") {
        const isBaseDrawer = this.checkLevelDrawer("but-menu-drwer");
        if (
          !this.isMobileMenuDrawer ||
          (this.isMobileMenuDrawer && isBaseDrawer)
        ) {
          this.closeDrawer(event);
        }
      }
    });
    this.drawerAttrObserve();
  }

  checkLevelDrawer(drawer) {
    let isBaseDrawer = true;
    const details = this.closest(drawer).querySelectorAll("details");
    details.forEach((detail) => {
      if (detail.hasAttribute("open") === true) {
        isBaseDrawer = false;
      }
    });

    return isBaseDrawer;
  }

  drawerAttrObserve() {
    const drawerAttrObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName == "open") {
          this.hasAttribute("open")
            ? this.applyOpenState()
            : this.applyCloseState();
        }
      });
    });

    drawerAttrObserver.observe(this, {
      attributes: true,
    });
  }

  cancelPendingClose() {
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
    // Bumping the token retires any close still awaiting its animations, so a
    // promise settling after the user has reopened cannot tear the drawer down.
    this._closeToken = (this._closeToken || 0) + 1;
  }

  async applyOpenState() {
    // Reopening must cancel any in-flight close so its stale timer/listener
    // cannot tear the drawer back down. iOS Safari often drops the fadeOut
    // animationend event, so the fallback timer is what finalizes the close -
    // and it can fire after the user has already reopened the drawer.
    this.cancelPendingClose();
    this.opener?.removeAttribute("disabled");
    this.opener?.setAttribute("aria-expanded", "true");
    this.setAttribute("aria-hidden", "false");
    this.dispatchEvent(new Event("opening"));
    this.bodyElement.classList.add("o-hidden");
    // One class change, one style recalc. Flipping "active" on and forcing a
    // reflow before dropping "drawer-out" made the browser build the exit
    // animation for a frame and immediately cancel it, which showed up as a
    // stutter at the start of the slide.
    this.classList.add("active");
    this.classList.remove("hidden-xs", "drawer-out");
    await this.animationsComplete();
    if (!this.hasAttribute("open")) return; // closed again while awaiting
    this.dispatchEvent(new Event("opened"));
    BUTHelper.trapFocus(this);
  }

  applyCloseState() {
    this.cancelPendingClose();
    BUTHelper.removeTrapFocus(this.opener);
    this.setAttribute("aria-hidden", "true");
    this.opener?.setAttribute("aria-expanded", "false");
    this.opener?.removeAttribute("disabled");
    this.dispatchEvent(new Event("closing"));
    this.classList.add("drawer-out");

    const token = this._closeToken;
    const finalizeClose = () => {
      if (token !== this._closeToken) return; // retired by a reopen
      this.cancelPendingClose();
      if (this.hasAttribute("open")) return; // reopened - do not tear down
      this.classList.remove("active", "drawer-out");
      this.classList.add("hidden-xs");
      this.dispatchEvent(new Event("closed"));
      this.bodyElement.classList.remove("o-hidden");
    };

    // Wait for every exit animation in the drawer, not just the overlay's. The
    // overlay used to be the sole trigger and it finishes first, so the panel
    // was stripped of its classes - and snapped off screen - while still
    // sliding out. getAnimations() flushes style, so the animations the class
    // just added are already there.
    this.animationsSettled().then(finalizeClose);
    // Safety fallback: iOS Safari can drop animation events entirely.
    this._closeTimer = setTimeout(finalizeClose, 600);
  }

  async animationsComplete() {
    const animations = this.getAnimations();
    await Promise.all(animations.map((animation) => animation.finished));
  }

  // Resolves once every finite animation in the drawer has finished. Infinite
  // ones (spinners inside the panel) never settle, so they are filtered out;
  // cancelled ones reject, which is expected and ignored.
  async animationsSettled() {
    const animations = this.getAnimations({ subtree: true }).filter(
      (animation) =>
        animation.effect?.getComputedTiming().iterations !== Infinity
    );
    await Promise.all(
      animations.map((animation) => animation.finished.catch(() => {}))
    );
  }

  openDrawer(opener) {
    BUTHelper.preventStickyHeaderReveal();
    this.opener = opener;
    this.removeAttribute("hidden");
    if (this.hasAttribute("open")) {
      // Attribute already present (e.g. a stuck drawer): toggleAttribute would
      // be a no-op and the observer would never fire, so re-apply the state.
      this.applyOpenState();
    } else {
      this.toggleAttribute("open", true);
    }
  }

  closeDrawer(event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleAttribute("open", false);
    this.classList.remove("is-open");
    this.querySelector(".js-drawer-message")?.setActiveMessage(false);
  }
}

class BUTDrawer extends BUTCoreDrawer {}
customElements.define("but-drwr", BUTDrawer);

class BUTMenuBadge extends BUTCustomComponent {
  constructor() {
    super();
  }

  static getBadgeMap() {
    if (this.badgeMap) return this.badgeMap;
    try {
      const dataEl = document.getElementById("drawerCustomBadgeData");
      if (!dataEl) return (this.badgeMap = {});
      const text = (dataEl.textContent || dataEl.innerText || "").trim();
      if (!text) return (this.badgeMap = {});
      const json = JSON.parse(text);
      const names = Array.isArray(json.menu_badge_name) ? json.menu_badge_name : [];
      const values = Array.isArray(json.menu_badge_value) ? json.menu_badge_value : [];
      const map = {};
      const limit = Math.min(names.length, values.length);
      for (let i = 0; i < limit; i++) {
        const key = String(names[i] || "").trim().toLowerCase().replace(/\s+/g, "");
        const val = String(values[i] || "").trim();
        if (key && val) map[key] = val;
      }
      this.badgeMap = map;
      return this.badgeMap;
    } catch (e) {
      this.badgeMap = {};
      return this.badgeMap;
    }
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Only run inside the drawer menu
    const drawer = this.closest("#menuDrawer");
    if (!drawer) return;

    const icon = this.closest(".badge__icon");
    if (!icon) return;

    const hash = (icon.getAttribute("data-menu-hash") || "").trim().toLowerCase();
    const map = BUTMenuBadge.getBadgeMap();
    const label = map[hash];

    if (label) {
      this.textContent = label;
      icon.setAttribute("data-has-badge", "true");
    } else {
      this.textContent = "";
      icon.removeAttribute("data-has-badge");
    }
  }
}

customElements.define("but-menu-badge", BUTMenuBadge);

class BUTMenuItem extends BUTCustomComponent {
  constructor() {
    super();
  }

  static getItemMap() {
    if (this.itemMap) return this.itemMap;
    try {
      const dataEl = document.getElementById("drawerCustomItemData");
      if (!dataEl) return (this.itemMap = {});
      const text = (dataEl.textContent || dataEl.innerText || "").trim();
      if (!text) return (this.itemMap = {});
      const json = JSON.parse(text);
      const names = Array.isArray(json.menu_item_name) ? json.menu_item_name : [];
      const values = Array.isArray(json.menu_item_value) ? json.menu_item_value : [];
      const map = {};
      const limit = Math.min(names.length, values.length);
      for (let i = 0; i < limit; i++) {
        const key = String(names[i] || "").trim().toLowerCase().replace(/\s+/g, "");
        const val = String(values[i] || "").trim();
        if (key && val) map[key] = val;
      }
      this.itemMap = map;
      return this.itemMap;
    } catch (e) {
      this.itemMap = {};
      return this.itemMap;
    }
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Only run inside the drawer menu
    const drawer = this.closest("#menuDrawer");
    if (!drawer) return;

    const item = this.closest(".menu__item__label");
    if (!item) return;

    const hash = (item.getAttribute("data-menu-hash") || "").trim().toLowerCase();
    const map = BUTMenuItem.getItemMap();
    const label = map[hash];

    if (label) {
      this.textContent = label;
      item.setAttribute("data-has-item", "true");
    } else {
      this.textContent = "";
      item.removeAttribute("data-has-item");
    }
  }
}

customElements.define("but-menu-item", BUTMenuItem);
/* Drawer */

/* Dialog */
class BUTDialogCore extends BUTCustomComponent {
  constructor() {
    super();
    this.dialog = this.$(".dialog");
    this.dialogOverlayElement = this.$(".js-dialog-overlay");
    this.closeBtn = this.$$(".js-dialog-close-btn");
    this.body = this.$(".js-dialog-body");
    this.container = this.$(".js-dialog-container");
    this.closeModalOnOverlayClick = this.dataset.closeModalOnOverlay || "true";
    this.scrollElement = this.$(".js-scroll-element");

    this.opener = null;
    this.bodyElement = document.body;
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.dialogOverlayElement?.addEventListener("click", () => {
      this.closeModal();
    });

    this.closeBtn.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.closeModal();
      });
    });

    this.addEventListener("click", (event) => {
      if (
        event.target.nodeName === this.tagName &&
        this.closeModalOnOverlayClick === "true"
      )
        this.closeModal();
    });

    this.addEventListener(
      "keyup",
      (evt) => evt.code.toUpperCase() === "ESCAPE" && this.closeModal()
    );
    this.dialogAttrObserve();
  }

  dialogAttrObserve() {
    let dialogAttrObserver = new MutationObserver((mutations, observer) => {
      mutations.forEach(async (mutation) => {
        if (mutation.attributeName == "hidden") {
          const isOpen = !this.hasAttribute("hidden");
          if (isOpen) {
            this.dispatchEvent(
              new CustomEvent("opening", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );

            await this.animationsComplete();
            this.dispatchEvent(
              new CustomEvent("opened", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            BUTHelper.trapFocus(this);
            this.bodyElement.classList.add("o-hidden");
          } else {
            BUTHelper.removeTrapFocus(this.opener);
            this.dispatchEvent(
              new CustomEvent("closing", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            await this.animationsComplete();
            this.dispatchEvent(
              new CustomEvent("closed", {
                detail: {
                  opener: this.opener,
                  dialog: this,
                },
              })
            );
            this.bodyElement.classList.remove("o-hidden");
          }
        }
      });
    });

    dialogAttrObserver.observe(this, {
      attributes: true,
    });
  }

  animationsComplete() {
    return Promise.allSettled(
      this.dialog
        .getAnimations({ subtree: true })
        .map((animation) => animation.finished)
    );
  }

  processBodyContent() {
    this.template = this.$("template");

    if (!this.template) return;
    let content = this.template.content;
    this.body.appendChild(content);
  }


  showModal(opener, template = false) {
    BUTHelper.preventStickyHeaderReveal();

    if (template) {
      this.processBodyContent();
    }
    this.opener = opener;
    this.toggleAttribute("hidden", false);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.classList.add("is-active");
        this.classList.remove("hidden-xs");
      });
    });
  }

  closeModal() {
    this.setAttribute("hidden", true);
    this.classList.add("drawer-out");
    // Read the exit length from CSS instead of hardcoding it, so the teardown
    // lands exactly when the animation does - a fixed 300ms left the dialog
    // frozen on its last frame once the timing tokens changed.
    const exitDuration =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--drawer-duration-out"
        )
      ) * 1000 || 300;
    clearTimeout(this._closeTimer);
    this._closeTimer = setTimeout(() => {
      this.classList.remove("is-active");
      this.classList.replace("drawer-out", "hidden-xs");
    }, exitDuration);
  }
}

// -------------------------------
// Fancybox Manager (moved from fancybox-init.js)
// -------------------------------
if (!customElements.get("but-fancybox-manager")) {
  class BUTFancyboxManager extends BUTCustomComponent {
    constructor() {
      super();
      this.fancyboxInstances = [];
      this.isInitialized = false;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.isInitialized) return;
      if (typeof Fancybox === "undefined") return;
      this.setupProductGallery();
      this.setupGeneralMedia();
      this.isInitialized = true;
    }

    setupProductGallery() {
      const galleryOptions = {
        Toolbar: {
          display: {
            left: ["infobar"],
            middle: [
              "zoomIn",
              "zoomOut",
              "toggle1to1",
              "rotateCCW",
              "rotateCW",
              "flipX",
              "flipY",
            ],
            right: ["slideshow", "thumbs", "close"],
          },
        },
        Carousel: {
          // Default is a 0.2s fade, which reads as a hard cut between images.
          transition: "slide",
          Thumbs: {
            type: "classic",
          },
        },
        on: {
          // Keep the page gallery on the image shown in the lightbox, so the
          // carousel and its active thumbnail match once the lightbox closes.
          "Carousel.change": (fancybox) => this.syncProductSlideshow(fancybox),
          close: (fancybox) => this.syncProductSlideshow(fancybox),
        },
        Images: { zoom: true, protected: true },
        Touch: { vertical: true, momentum: true },
        showClass: "f-fadeIn",
        hideClass: "f-fadeOut",
        trapFocus: true,
        autoFocus: true,
        placeFocusBack: true,
      };
      // Bind to all product gallery instances (pattern: product-gallery-{sectionId})
      this.fancyboxInstances.push(
        Fancybox.bind("[data-fancybox^='product-gallery']", galleryOptions)
      );
    }

    syncProductSlideshow(fancybox) {
      const triggerEl = fancybox?.getSlide()?.triggerEl;
      const mediaId = triggerEl?.closest("[data-media-id]")?.dataset.mediaId;
      const slideshow = triggerEl?.closest("but-prd-slideshow");
      if (mediaId && typeof slideshow?.showMedia === "function") {
        slideshow.showMedia(mediaId);
      }
    }

    setupGeneralMedia() {
      const generalOptions = {
        Toolbar: {
          display: { left: ["infobar"], middle: ["zoomIn", "zoomOut", "toggle1to1"], right: ["close"] },
        },
      };
      this.fancyboxInstances.push(
        Fancybox.bind("[data-fancybox]", generalOptions)
      );
    }


    destroy() {
      this.fancyboxInstances.forEach((instance) => {
        if (instance && typeof instance.destroy === "function") instance.destroy();
      });
      this.fancyboxInstances = [];
      this.isInitialized = false;
    }

    static init() {
      let instance = BUTHelper.qs("but-fancybox-manager");
      if (!instance) {
        instance = document.createElement("but-fancybox-manager");
        document.body.appendChild(instance);
      }
      return instance;
    }
  }
  customElements.define("but-fancybox-manager", BUTFancyboxManager);
  document.addEventListener("DOMContentLoaded", function () {
    if (!BUTHelper.qs("but-fancybox-manager")) {
      BUTFancyboxManager.init();
    }
  });
}

// -------------------------------
// Swiper Manager (moved from swiper-init.js)
// -------------------------------
if (!customElements.get("but-swiper-manager")) {
  class BUTSwiperManager extends BUTCustomComponent {
    constructor() {
      super();
      this.instances = new Map();
    }
    connectedCallback() {
      this.bindThemeEvents();
      this.initAll();
    }
    bindThemeEvents() {
      document.addEventListener("shopify:section:load", () => this.initAll());
      document.addEventListener("but:theme:updated", () => this.reinitAll());
    }
    initAll() {
      if (typeof Swiper === "undefined") return;
      const slideshows = BUTHelper.qsa('but-prd-slideshow[data-swiper="true"]');
      slideshows.forEach((el) => this.initOne(el));
    }
    initOne(rootEl) {
      if (this.instances.has(rootEl)) return;
      const containerEl = rootEl.querySelector(".js-product-slideshow") || rootEl;
      const wrapperEl = rootEl.querySelector(".js-carousel-items");
      const slideEls = rootEl.querySelectorAll(".js-carousel-item");
      if (!wrapperEl || !slideEls.length) return;
      const nextBtn = rootEl.querySelector(
        ".js-slideshow-next-btn, .js-carousel-next-btn"
      );
      const prevBtn = rootEl.querySelector(
        ".js-slideshow-prev-btn, .js-carousel-prev-btn"
      );
      const paginationEl = rootEl.querySelector(".js-carousel-pagination");
      const swiper = new Swiper(containerEl, {
        wrapperClass: "js-carousel-items",
        slideClass: "js-carousel-item",
        slideActiveClass: "is-active-swiper-slide",
        slideVisibleClass: "is-visible-swiper-slide",
        containerModifierClass: "swiper-",
        slidesPerView: 1,
        spaceBetween: 0,
        watchSlidesProgress: true,
        autoHeight: true,
        resistanceRatio: 0.85,
        navigation: {
          nextEl: nextBtn || undefined,
          prevEl: prevBtn || undefined,
          disabledClass: "is-disabled",
          hiddenClass: "is-hidden",
        },
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true,
              bulletClass: "swiper-bullet",
              bulletActiveClass: "is-active",
            }
          : undefined,
        keyboard: { enabled: true },
        grabCursor: true,
      });
      this.instances.set(rootEl, swiper);
    }
    reinitAll() {
      this.instances.forEach((swiper, el) => {
        try {
          swiper.destroy(true, true);
        } catch (_) {}
        this.instances.delete(el);
      });
      this.initAll();
    }
  }
  customElements.define("but-swiper-manager", BUTSwiperManager);
  document.addEventListener("DOMContentLoaded", function () {
    if (!BUTHelper.qs("but-swiper-manager")) {
      document.body.appendChild(document.createElement("but-swiper-manager"));
    }
  });
  
  // Expose method to get Swiper instance
  BUTSwiperManager.getInstance = function() {
    const manager = BUTHelper.qs("but-swiper-manager");
    return manager ? manager.instances : null;
  };
}

// -------------------------------
// BUTSwiper — unified Swiper carousel component
// -------------------------------
// One web component drives every content carousel in the theme (slideshow,
// product lists, media-with-text, product navigation, cart drawer related).
// Configuration is a single JSON blob on `data-config`, emitted by
// `snippets/carousel-config.liquid`. Controls (arrows + pagination) are rendered
// by `snippets/carousel-controls.liquid` and found via `.js-swiper-*` hooks.
//
// Best practice for adding a carousel to this theme:
//   1. Render `<but-swiper data-config='{% render "carousel-config", ... %}'>`.
//   2. Put the slides inside `<div class="swiper"><div class="swiper-wrapper">`.
//   3. Render `{% render 'carousel-controls', settings: section.settings %}`.
//   4. Never call `new Swiper(...)` directly — grab the instance with
//      `BUTSwiper.get(el)` / `BUTSwiper.getForSection(id)` if you need it.
// -------------------------------

// Fires `cb` once, as soon as the global `Swiper` is available.
// `swiper.min.js` is deferred ahead of theme.js, so deferred ordering almost
// always has it defined by now and this resolves synchronously. The listener
// covers the rest: `but:swiper:ready` (dispatched from the script tag's onload)
// and `load`, in case the script was served from a path that skipped the
// onload. Until then the carousel shows its shimmer (carousel.css).
window.BUTSwiperReady = function (cb) {
  if (window.Swiper) {
    cb();
    return;
  }
  let done = false;
  const handler = () => {
    if (done || !window.Swiper) return;
    done = true;
    document.removeEventListener("but:swiper:ready", handler);
    window.removeEventListener("load", handler);
    cb();
  };
  document.addEventListener("but:swiper:ready", handler);
  window.addEventListener("load", handler);
};

if (!customElements.get("but-swiper")) {
  const swiperRegistry = new WeakMap();

  // Shared observer: carousels mount only as they approach the viewport.
  const lazyObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        lazyObserver.unobserve(entry.target);
        entry.target.mount();
      });
    },
    { rootMargin: "200px 0px" },
  );

  const EFFECTS_SINGLE_SLIDE = ["fade", "cube", "flip", "cards"];

  // `scrollbar` in data-config is either the object carousel-config emits from
  // the `carousel_scrollbar_*` settings, or the shorthand a hand-written config
  // passes ("hide" = auto-hide after interaction, any other truthy = always on).
  // Returns null when there is no scrollbar, so one truthiness check covers both.
  const normalizeScrollbar = (raw) => {
    if (!raw) return null;
    if (typeof raw !== "object") {
      return {
        draggable: true,
        hide: raw === "hide",
        placement: "inside",
        position: "bottom",
      };
    }
    if (raw.enabled === false) return null;
    return {
      draggable: !!raw.draggable,
      hide: raw.hide !== false,
      placement: raw.placement || "inside",
      position: raw.position || "bottom",
      trackColor: raw.trackColor || "",
      thumbColor: raw.thumbColor || "",
    };
  };

  class BUTSwiper extends BUTCustomComponent {
    constructor() {
      super();
      this.instance = null;
      this._booted = false;
      this._onBreakpoint = this._onBreakpoint.bind(this);
      this._onEdge = this._onEdge.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onShopifyBlockSelect = this._onShopifyBlockSelect.bind(this);
      this._onShopifyBlockDeselect = this._onShopifyBlockDeselect.bind(this);
    }

    connectedCallback() {
      this.cfg = this._parseConfig();
      this._applyModifierClasses();
      window.BUTSwiperReady(() => this._boot());
      this._bindShopifyEvents();
    }

    disconnectedCallback() {
      lazyObserver.unobserve(this);
      this._unbindShopifyEvents();
      this.destroy();
    }

    _parseConfig() {
      let cfg = {};
      try {
        cfg = JSON.parse(this.dataset.config || "{}") || {};
      } catch (e) {
        console.warn("[BUTSwiper] invalid data-config", e, this);
      }
      this.sb = normalizeScrollbar(cfg.scrollbar);
      return cfg;
    }

    _boot() {
      if (this._booted) return;
      this._booted = true;
      if (this.cfg.lazy === false) {
        this.mount();
      } else {
        lazyObserver.observe(this);
      }
    }

    mount() {
      if (this.instance) return;
      const container = this.$(".swiper");
      const wrapper = container && container.querySelector(".swiper-wrapper");
      if (!container || !wrapper || !wrapper.children.length) return;

      this._placeScrollbar(container);
      // `is-swiper-ready` goes on first: it lifts the pre-mount sizing and
      // shimmer in carousel.css, so Swiper measures the real slides (the
      // autoHeight carousels collapse every slide but the first before mount).
      // Nothing paints in between, and MutationObserver watchers of this class
      // run as a microtask - after the instance below is registered.
      this.classList.add("is-swiper-ready");
      this.instance = new window.Swiper(container, this._buildOptions());
      swiperRegistry.set(this, this.instance);

      this.instance.on("breakpoint", this._onBreakpoint);
      this.instance.on(
        "fromEdge toEdge afterInit slidesLengthChange",
        this._onEdge,
      );
      this.instance.on("resize", this._onResize);
      this._bindAutoplayToggle();
      this._bindBulletProgress();
      this._onBreakpoint();
      this._onEdge();
    }

    // Bullets + autoplay: the active dot's fill tracks the time left before the
    // next slide (carousel.css reads --but-swiper-pg-progress while the element
    // has `is-autoplay-progress`). Without autoplay, or once it is stopped, the
    // class comes off and the dot falls back to its one-off CSS sweep.
    _bindBulletProgress() {
      const s = this.instance;
      const el = this.$(".js-swiper-pagination");
      if (
        !el ||
        !s.autoplay ||
        !s.params.autoplay ||
        !s.params.autoplay.enabled ||
        !s.params.pagination ||
        s.params.pagination.type !== "bullets"
      ) {
        return;
      }
      const setProgress = (p) =>
        el.style.setProperty("--but-swiper-pg-progress", p);
      const setRunning = (running) => {
        el.classList.toggle("is-autoplay-progress", running);
        setProgress(0);
      };
      s.on("autoplayTimeLeft", (sw, timeLeft, left) => {
        setProgress(Math.min(1, Math.max(0, 1 - left)).toFixed(3));
      });
      s.on("slideChange", () => setProgress(0));
      s.on("autoplayStart", () => setRunning(true));
      s.on("autoplayStop", () => setRunning(false));
      setRunning(!!s.autoplay.running);
    }

    // The scrollbar is absolutely positioned by Swiper's own CSS, so which
    // element it hangs off decides what it overlays: "inside" has to sit in the
    // frame, or it would clear the pagination rather than the slides whenever
    // the pagination is outside/bottom (the default). "outside" belongs in the
    // host's flex flow. Both directions run, so a theme-editor remount that
    // flips the setting puts it back.
    _placeScrollbar(container) {
      const el = this.$(".js-swiper-scrollbar");
      if (!el) return;
      const parent = el.parentElement;
      // A section that nests the chrome in a bar of its own (slideshow) keeps
      // laying it out itself - only ever move between the host and the frame.
      if (parent !== this && parent !== container) return;
      const target =
        this.sb && this.sb.placement === "inside" ? container : this;
      if (target && parent !== target) target.appendChild(el);
    }

    _bindAutoplayToggle() {
      const btn = this.$(".js-swiper-autoplay-toggle");
      if (!btn || !this.instance.autoplay) {
        btn && btn.setAttribute("hidden", "");
        return;
      }
      const setState = (playing) => {
        btn.classList.toggle("is-playing", playing);
        btn.setAttribute("aria-pressed", String(playing));
        const label = playing ? btn.dataset.labelPause : btn.dataset.labelPlay;
        if (label) btn.setAttribute("aria-label", label);
      };
      btn.addEventListener("click", () => {
        if (this.instance.autoplay.running && !this.instance.autoplay.paused) {
          this.instance.autoplay.stop();
          setState(false);
        } else {
          this.instance.autoplay.start();
          setState(true);
        }
      });
      this.instance.on("autoplayStop", () => setState(false));
      this.instance.on("autoplayStart", () => setState(true));
      setState(this.instance.autoplay.running);
    }

    destroy() {
      if (!this.instance) return;
      try {
        this.instance.destroy(true, true);
      } catch (e) {
        /* noop */
      }
      this.instance = null;
      swiperRegistry.delete(this);
      this.classList.remove("is-swiper-ready");
      const pagEl = this.$(".js-swiper-pagination");
      if (pagEl) {
        pagEl.classList.remove("is-autoplay-progress");
        pagEl.style.removeProperty("--but-swiper-pg-progress");
      }
    }

    remount() {
      this.destroy();
      this.cfg = this._parseConfig();
      this._applyModifierClasses();
      this.mount();
    }

    // ---- option builder (pure-ish: only reads DOM for control elements) ----
    _buildOptions() {
      const cfg = this.cfg;
      const bp = cfg.breakpoint || 768;
      const spv = cfg.slidesPerView || {};
      const sb = cfg.spaceBetween || {};
      const spvMobile = spv.mobile != null ? spv.mobile : 1;
      const spvDesktop = spv.desktop != null ? spv.desktop : spvMobile;
      const sbMobile = sb.mobile != null ? sb.mobile : 0;
      const sbDesktop = sb.desktop != null ? sb.desktop : sbMobile;
      const enabled = cfg.enabled || {};
      const designMode = !!(window.Shopify && window.Shopify.designMode);

      const opts = {
        slidesPerView: spvMobile,
        spaceBetween: sbMobile,
        speed: cfg.speed != null ? cfg.speed : 500,
        grabCursor: cfg.grabCursor !== false,
        watchOverflow: true,
        threshold: 3,
        a11y: { enabled: cfg.a11y !== false },
        keyboard: { enabled: true, onlyInViewport: true },
        enabled: enabled.mobile !== false,
        breakpoints: {
          [bp]: {
            slidesPerView: spvDesktop,
            spaceBetween: sbDesktop,
            enabled: enabled.desktop !== false,
          },
        },
      };

      // loop: "off" | "on"
      opts.loop = cfg.loop === "on";

      // transition effect
      const effect = cfg.effect || "slide";
      if (effect !== "slide") {
        opts.effect = effect;
        if (effect === "fade") opts.fadeEffect = { crossFade: true };
        if (EFFECTS_SINGLE_SLIDE.indexOf(effect) !== -1) {
          opts.slidesPerView = 1;
          opts.breakpoints[bp].slidesPerView = 1;
        }
      }

      // free mode
      if (cfg.freeMode && cfg.freeMode.enabled) {
        opts.freeMode = {
          enabled: true,
          momentum: cfg.freeMode.momentum !== false,
          momentumRatio: cfg.freeMode.momentumRatio || 1,
          momentumVelocityRatio: cfg.freeMode.velocityRatio || 1,
        };
      }

      // autoplay (paused in the theme editor so merchants can arrange slides)
      if (cfg.autoplay && cfg.autoplay.enabled && !designMode) {
        opts.autoplay = {
          delay: cfg.autoplay.delay || 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      // scrollbar (opt-in via config; the element comes from carousel-controls)
      const scrollbarEl =
        this.$(".js-swiper-scrollbar") || this.$(".swiper-scrollbar");
      if (this.sb && scrollbarEl) {
        opts.scrollbar = {
          el: scrollbarEl,
          draggable: this.sb.draggable,
          hide: this.sb.hide,
          lockClass: "is-locked",
        };
      }

      // navigation
      const nextEl = this.$(".js-swiper-next");
      const prevEl = this.$(".js-swiper-prev");
      const nav = cfg.navigation || {};
      if (nav.enabled !== false && (nextEl || prevEl)) {
        opts.navigation = {
          nextEl: nextEl || undefined,
          prevEl: prevEl || undefined,
          disabledClass: "is-disabled",
          lockClass: "is-locked",
          hiddenClass: "is-hidden",
        };
      }

      // pagination
      const pagEl = this.$(".js-swiper-pagination");
      const pag = cfg.pagination || {};
      if (pag.enabled !== false && pagEl) {
        const type = pag.type || "bullets";
        opts.pagination = {
          el: pagEl,
          type: type,
          clickable: type === "bullets",
          dynamicBullets: type === "bullets" && pag.dynamicBullets === true,
          progressbarOpposite: !!pag.progressbarOpposite,
          lockClass: "is-locked",
        };
        if (pag.progressbarColor) {
          pagEl.style.setProperty(
            "--swiper-pagination-color",
            pag.progressbarColor,
          );
        }
      }

      // let callers layer on advanced Swiper options verbatim
      if (cfg.swiperOptions && typeof cfg.swiperOptions === "object") {
        Object.assign(opts, cfg.swiperOptions);
      }

      return opts;
    }

    _applyModifierClasses() {
      const cfg = this.cfg || {};
      const nav = cfg.navigation || {};
      const pag = cfg.pagination || {};
      const navPos = nav.position || "inside";
      const pagPlacement = pag.placement || "outside";
      const pagPos = pag.position || "bottom";
      const pagType = pag.type || "bullets";
      this.classList.toggle("but-swiper--nav-inside", navPos === "inside");
      this.classList.toggle("but-swiper--nav-outside", navPos === "outside");
      this.classList.toggle("but-swiper--pg-inside", pagPlacement === "inside");
      this.classList.toggle(
        "but-swiper--pg-outside",
        pagPlacement === "outside",
      );
      this.classList.toggle("but-swiper--pg-top", pagPos === "top");
      this.classList.toggle("but-swiper--pg-bottom", pagPos === "bottom");
      this.classList.toggle("but-swiper--pg-bullets", pagType === "bullets");
      this.classList.toggle(
        "but-swiper--pg-progressbar",
        pagType === "progressbar",
      );
      this.classList.toggle("but-swiper--pg-fraction", pagType === "fraction");
      this.classList.toggle(
        "but-swiper--free",
        !!(cfg.freeMode && cfg.freeMode.enabled),
      );

      // Scrollbar: one gate class plus the placement pair, mirroring the
      // pagination. The two colours ride on the host as local tokens (see
      // carousel.css) so an unset setting falls back to the theme ramp.
      const sb = this.sb;
      this.classList.toggle("but-swiper--sb", !!sb);
      this.classList.toggle(
        "but-swiper--sb-inside",
        !!sb && sb.placement === "inside",
      );
      this.classList.toggle(
        "but-swiper--sb-outside",
        !!sb && sb.placement === "outside",
      );
      this.classList.toggle("but-swiper--sb-top", !!sb && sb.position === "top");
      this.classList.toggle(
        "but-swiper--sb-bottom",
        !!sb && sb.position === "bottom",
      );
      // Written every time, not only when set: a remount in the theme editor
      // has to be able to clear a colour the merchant just removed.
      const setToken = (name, value) => {
        if (value) this.style.setProperty(name, value);
        else this.style.removeProperty(name);
      };
      setToken("--but-swiper-sb-track", sb && sb.trackColor);
      setToken("--but-swiper-sb-thumb", sb && sb.thumbColor);
    }

    _onBreakpoint() {
      if (!this.instance) return;
      this.classList.toggle("but-swiper--off", this.instance.enabled === false);
    }

    // On resize Swiper re-measures the scrollbar track and thumb but leaves the
    // thumb at the offset it had on the old track until the next move - past the
    // end of a narrower track once the carousel has been scrolled. Bound after
    // Swiper's own resize handler, so the sizes are already current here.
    _onResize() {
      const scrollbar = this.instance && this.instance.scrollbar;
      if (scrollbar && scrollbar.el) scrollbar.setTranslate();
    }

    _onEdge() {
      if (!this.instance) return;
      const loop = this.cfg.loop === "on";
      const prevEl = this.$(".js-swiper-prev");
      const nextEl = this.$(".js-swiper-next");
      const atStart = !loop && this.instance.isBeginning;
      const atEnd = !loop && this.instance.isEnd;
      if (prevEl) prevEl.toggleAttribute("disabled", atStart);
      if (nextEl) nextEl.toggleAttribute("disabled", atEnd);
    }

    // ---- theme editor: jump to the slide the merchant selects ----
    _bindShopifyEvents() {
      if (!(window.Shopify && window.Shopify.designMode)) return;
      document.addEventListener(
        "shopify:block:select",
        this._onShopifyBlockSelect,
      );
      document.addEventListener(
        "shopify:block:deselect",
        this._onShopifyBlockDeselect,
      );
    }

    _unbindShopifyEvents() {
      document.removeEventListener(
        "shopify:block:select",
        this._onShopifyBlockSelect,
      );
      document.removeEventListener(
        "shopify:block:deselect",
        this._onShopifyBlockDeselect,
      );
    }

    _slideIndexOf(node) {
      const slide = node && node.closest(".swiper-slide");
      if (!slide || !this.instance) return -1;
      const dup = slide.getAttribute("data-swiper-slide-index");
      if (dup != null) return parseInt(dup, 10);
      const real = Array.prototype.filter.call(
        this.instance.slides,
        (s) => !s.classList.contains("swiper-slide-duplicate"),
      );
      return real.indexOf(slide);
    }

    _onShopifyBlockSelect(evt) {
      if (!this.instance || !this.contains(evt.target)) return;
      const idx = this._slideIndexOf(evt.target);
      if (idx < 0) return;
      this.instance.autoplay && this.instance.autoplay.stop();
      if (this.instance.params.loop) this.instance.slideToLoop(idx);
      else this.instance.slideTo(idx);
    }

    _onShopifyBlockDeselect() {
      if (!this.instance) return;
      if (
        this.cfg.autoplay &&
        this.cfg.autoplay.enabled &&
        this.instance.autoplay
      ) {
        this.instance.autoplay.start();
      }
    }
  }

  BUTSwiper.get = (el) =>
    el ? swiperRegistry.get(el) || el.instance || null : null;
  BUTSwiper.getForSection = (sectionId) => {
    const host = document.querySelector(
      `but-swiper[data-section-id="${sectionId}"], #shopify-section-${sectionId} but-swiper`,
    );
    return host ? BUTSwiper.get(host) : null;
  };
  window.BUTSwiper = BUTSwiper;
  customElements.define("but-swiper", BUTSwiper);
}

// -------------------------------
// Product Navigation Slideshow (product-navigation block)
// -------------------------------
// Thin layer over a child <but-swiper>: keeps the block's own indicator (titled
// pills, dots, fraction, progress bar or banner tabs) in sync with the slider.
// All Swiper lifecycle lives in BUTSwiper.
class BUTProductNavSlideshow extends BUTCustomComponent {
  constructor() {
    super();
    this.onBulletClick = this.onBulletClick.bind(this);
    this._sync = this._sync.bind(this);
    this._onSwiperDestroy = this._onSwiperDestroy.bind(this);
  }

  connectedCallback() {
    this.host = this.$("but-swiper");
    this.bullets = Array.from(this.$$(".js-product-nav-slideshow-bullet"));
    this.fractionCurrentEl = this.$(".js-product-nav-slideshow-fraction-current");
    this.progressbarFillEl = this.$(".js-product-nav-slideshow-progressbar-fill");
    const hasIndicator =
      this.bullets.length || this.fractionCurrentEl || this.progressbarFillEl;
    if (!this.host || !hasIndicator) return;
    this.bullets.forEach((b) =>
      b.addEventListener("click", this.onBulletClick),
    );

    // <but-swiper> mounts lazily (on scroll into view), so the Swiper instance
    // usually isn't ready yet. Watch the host for the `is-swiper-ready` class it
    // gets on mount (and again after any theme-editor remount) instead of giving
    // up after a fixed number of polls.
    this._mo = new MutationObserver(() => this._bind());
    if (!this._bind()) this._watch();
  }

  _watch() {
    if (this._mo && this.host) {
      this._mo.observe(this.host, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  _swiper() {
    return (
      this.swiper || (window.BUTSwiper && window.BUTSwiper.get(this.host)) || null
    );
  }

  // Wire the bullet list to the Swiper instance once it exists. Returns true
  // when bound so callers know to stop watching.
  _bind() {
    if (this.swiper) return true;
    const s = this._swiper();
    if (!s) return false;
    this.swiper = s;
    s.on("slideChange", this._sync);
    s.on("afterInit", this._sync);
    s.on("destroy", this._onSwiperDestroy);
    if (this._mo) this._mo.disconnect();
    this._sync();
    return true;
  }

  _onSwiperDestroy() {
    // A remount (theme editor, breakpoint) throws the instance away; pick up
    // the new one when it lands.
    this.swiper = null;
    this._watch();
  }

  onBulletClick(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10) || 0;
    // Reflect the click straight away: the active pill must never lag the
    // slider, or stay behind entirely while the slider is still mounting.
    this._setActive(index);
    this._bind();
    const s = this._swiper();
    if (!s) return;
    if (typeof s.slideToLoop === "function" && s.params.loop)
      s.slideToLoop(index);
    else s.slideTo(index);
  }

  _sync() {
    const s = this._swiper();
    if (!s || !this.bullets) return;
    this._setActive(s.realIndex || 0);
  }

  _setActive(index) {
    this.bullets.forEach((b, i) =>
      b.classList.toggle("is-active", i === index),
    );
    // Bullets in an overflowing row (the banner-tabs titles) keep the active one in view.
    const activeBullet = this.bullets[index];
    const scroller = activeBullet?.closest(".js-product-nav-slideshow-scroller");
    if (scroller && scroller.scrollWidth > scroller.clientWidth) {
      const rowRect = scroller.getBoundingClientRect();
      const bulletRect = activeBullet.getBoundingClientRect();
      scroller.scrollTo({
        left:
          scroller.scrollLeft +
          bulletRect.left -
          rowRect.left -
          (rowRect.width - bulletRect.width) / 2,
        behavior: "smooth",
      });
    }
    if (this.fractionCurrentEl) {
      this.fractionCurrentEl.textContent = index + 1;
    }
    if (this.progressbarFillEl) {
      const total = parseInt(this.progressbarFillEl.dataset.total, 10) || 1;
      const pct = total > 1 ? (index / (total - 1)) * 100 : 100;
      this.progressbarFillEl.style.width = `${pct}%`;
    }
  }

  disconnectedCallback() {
    if (this._mo) this._mo.disconnect();
    if (this.bullets) {
      this.bullets.forEach((b) =>
        b.removeEventListener("click", this.onBulletClick),
      );
    }
  }
}

if (!customElements.get("but-product-nav-slideshow")) {
  customElements.define("but-product-nav-slideshow", BUTProductNavSlideshow);
}

/* Color Swatch*/
class BUTColorSwatch extends BUTCustomComponent {
  constructor() {
    super();

    //this.$$ = this.querySelectorAll.bind(this);
    this.json = null;
    this.jsonDataElement =
      BUTHelper.qs(`#colorSwatchData[type="application/json"]`) || null;

    this.variantSwatchItems = this.$$(".js-variant-swatch-item") || [];
    if (!this.jsonDataElement || this.variantSwatchItems.length == 0) {
      return;
    }
    this.bindEventHandlers();
  }

  onObserverHandler() {
    let observe = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.init();

          observer.unobserve(this);
        }
      });
    });
    observe.observe(this);
  }

  init() {
    this.json = JSON.parse(this.jsonDataElement.textContent);
    this.processJsonData();
    for (let i = 0, n = this.variantSwatchItems.length; i < n; i++) {
      let e = this.variantSwatchItems[i];

      const jsonData = this.json[`${e.dataset.optionValue}`];
      let classSwatchType = "";

      if (e.dataset.swatchSource !== "variant_image") {
        const optionValue = e.dataset.optionValue;
        const swatchOptionValue = e.dataset.swatchOptionValue;

        const applyStyles = (type, color = "", image = "") => {
          classSwatchType = type;
          e.style.backgroundColor = color;
          e.style.backgroundImage = image ? `url("${image}")` : "";
          e.style.backgroundSize = image ? "cover" : "";
          e.style.backgroundRepeat = image ? "no-repeat" : "";
        };

        if (jsonData !== undefined) {
          const isHexColor = BUTHelper.isHexColor(jsonData);
          const isImage = BUTHelper.isImage(jsonData);

          if (isImage) {
            applyStyles("image", "", jsonData);
          } else if (isHexColor) {
            applyStyles("color", jsonData);
          }
        } else if (BUTHelper.isColor(optionValue)) {
          applyStyles("color", optionValue);
        }

        if (swatchOptionValue) {
          const swatchHexColor = BUTHelper.isHexColor(swatchOptionValue);
          const swatchImage = BUTHelper.isImage(swatchOptionValue);

          if (swatchImage) {
            applyStyles("image", "", swatchOptionValue);
          } else if (swatchHexColor) {
            applyStyles("color", swatchOptionValue);
          }
        }

        if (e.style.backgroundImage || e.style.backgroundColor) {
          if (classSwatchType)
            e.classList.add(`clr-swh__type--${classSwatchType}`);
          e.classList.add("clr-swh__has-value");
          e.querySelector(".js-variant-option-label")?.classList.add(
            "hide-value"
          );
        }
      }
    }
  }

  processJsonData() {
    if (this.json) {
      this.json = Object.assign.apply(
        {},
        this.json.color_swatch_name.map((v, i) => ({
          [v]: this.json.color_swatch_value[i],
        }))
      );
    }
  }

  bindEventHandlers() {
    this.onObserverHandler();
  }
}
class BUTVariantSwatch extends BUTColorSwatch {
  bindEventHandlers() {
    this.onObserverHandler();
    this.variantSwatchItems.forEach((e) => {
      e.addEventListener("click", (subEvent) => {
        this.changeVariantImage(subEvent.currentTarget);
      });
    });
  }
  changeVariantImage(ele) {
    const mainImage = BUTHelper.qs(`#${ele.dataset.productImageId}`);
    const mainImageLink = BUTHelper.qsa(`.${ele.dataset.productLinkClass}`);
    const variantImageTemplate = ele.querySelector("template");
    const butImage = ele
      .closest(".mini-card")
      ?.querySelector("but-image-atf img");
    if (mainImage && variantImageTemplate) {
      this.setButtonVisibility(false);
      const variantImage =
        variantImageTemplate.content.firstElementChild.cloneNode(true);
      this.updateImage(mainImage, variantImage);
      if (butImage) this.updateImage(butImage, variantImage);
      if (mainImageLink) {
        mainImageLink.forEach((link) => {
          link.href = variantImage.getAttribute("data_url");
        });
      }
      ele.setAttribute("aria-current", "true");
      ele.classList.add("btn-active");
      ele.focus();
    }
  }
  updateImage(targetImage, sourceImage) {
    targetImage.src = sourceImage.src;
    targetImage.srcset = sourceImage.srcset || sourceImage.src;
  }
  setButtonVisibility(flag) {
    if (this.variantSwatchItems) {
      this.variantSwatchItems.forEach((e) => {
        if (flag) {
          e.setAttribute("aria-current", "true");
          e.classList.add("btn-active");
        } else {
          e.removeAttribute("aria-current");
          e.classList.remove("btn-active");
        }
      });
    }
  }
}
customElements.define("but-variant-swtch", BUTVariantSwatch);

class BUTProductCardVariantButton extends BUTVariantSwatch {}
customElements.define(
  "but-product-card-variant-button",
  BUTProductCardVariantButton
);

/* Color Swatch*/

class BUTMainProductVariantSwatch extends BUTColorSwatch {}

customElements.define("but-prd-variant-swtch", BUTMainProductVariantSwatch);

class BUTMainProductVariantSwatchWSelect extends BUTColorSwatch {}

customElements.define(
  "but-prd-variant-swtch-w-select",
  BUTMainProductVariantSwatchWSelect
);

class BUTMainCollectionProductVariantSwatch extends BUTColorSwatch {}

customElements.define(
  "but-coll-prd-variant-swtch",
  BUTMainCollectionProductVariantSwatch
);


class BUTMainSearchVariantSwatch extends BUTColorSwatch {}

customElements.define("but-srch-variant-swtch", BUTMainSearchVariantSwatch);

class BUTShowAllOption extends BUTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.dataStepExpand = parseInt(this.dataset.stepExpand);
    this.btn = this.$(".js-expandable-content-btn");

    if (this.dataStepExpand == 0) return;

    this.visibilityShowMore();
    this.hidenFilterItem();
    this.bindEventHandlers();
  }

  visibilityShowMore() {
    if (
      this.querySelectorAll(".filter-form__item").length > this.dataStepExpand
    ) {
      this.btn.parentElement.classList.remove("d-none");
    }
  }
  hidenFilterItem() {
    this.querySelectorAll(".filter-form__item").forEach((ele, index) => {
      if (index + 1 > this.dataStepExpand) {
        ele.classList.add("d-none-important");
      }
    });
  }

  bindEventHandlers() {
    this.btn.addEventListener("click", (e) => {
      this.querySelectorAll(".filter-form__item").forEach((ele, index) => {
        ele.classList.remove("d-none-important");
        this.btn.parentElement.classList.add("d-none");
      });
    });
  }
}
customElements.define("but-show-all-options", BUTShowAllOption);



class BUTReadMore extends BUTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.contents = this.$$(".js-comp-drawer-des .js-expandable-content");
    this.btns = this.$$(".js-comp-drawer-des .js-expandable-content-btn");

    this.contents.forEach((content, index) => {
      const btn = this.btns[index];

      if (content.scrollHeight > content.clientHeight) {
        content.setAttribute("data-expanded", "false");
        content.classList.add("expandable-content--expandable");
      } else {
        content.setAttribute("data-expanded", "true");
      }

      btn.addEventListener("click", () => {
        let clientHeight = content.scrollHeight;

        if (content.getAttribute("data-expanded") == "true") {
          content.setAttribute("data-expanded", "false");
          content.style.maxHeight = "120px";
          btn.innerHTML = btn.getAttribute("data-view-more");
        } else {
          content.setAttribute("data-expanded", "true");
          content.style.maxHeight = `${clientHeight}px`;
          btn.innerHTML = btn.getAttribute("data-view-less");
        }
      });
    });
  }
}

customElements.define("but-read-more", BUTReadMore);

class BUTShareProductButton extends BUTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.webShareApiContainer = this.$(`.js-web-share-api-container`);
    this.webShareApiButton = this.$(`.js-web-share-api-btn`);

    this.noneWebShareApiContainer = this.$(`.js-none-web-share-api-container`);
    this.noneWebShareApiButton = this.$(`.js-none-web-share-api-btn`);

    this.copyLinkButton = this.$(`.js-social-share-copy-link`);
    this.init();
  }

  init() {
    if (navigator.share) {
      this.webShareApiContainer.removeAttribute("hidden");
      this.webShareApiButton.addEventListener("click", () => {
        navigator
          .share({
            url: this.dataset.productUrl,
            title: document.title,
          })
          .then(() => {
            console.log("Thanks for sharing!");
          })
          .catch(console.error);
      });
    } else {
      this.noneWebShareApiContainer.removeAttribute("hidden");
      this.copyLinkButton.addEventListener("click", (e) => {
        this.copyToClipboard(e.currentTarget);
      });
    }
  }

  copyToClipboard(e) {
    navigator.clipboard.writeText(this.dataset.productUrl).then(() => {
      e.querySelector(".js-social-share-copy-link-label").textContent =
        e.dataset.linkCopiedToClipboard;
    });
  }
}
customElements.define("but-share-prd-btn", BUTShareProductButton);

class BUTCopyCode extends BUTCustomComponent {
  constructor() {
    super();
    this.button = this.$(".js-copy-code-button");
    this.status = this.$(".js-copy-code-status");
  }

  connectedCallback() {
    this.button?.addEventListener("click", () => this.copy());
  }

  copy() {
    const code = this.dataset.code;
    if (!code) return;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(() => this.showCopied())
        .catch(() => this.legacyCopy(code));
    } else {
      this.legacyCopy(code);
    }
  }

  // navigator.clipboard is missing on non-secure origins (theme preview over http).
  legacyCopy(code) {
    const field = document.createElement("textarea");
    field.value = code;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand("copy");
    field.remove();
    if (copied) this.showCopied();
  }

  showCopied() {
    this.classList.add("is-copied");
    if (this.status) this.status.textContent = this.status.dataset.message;
    clearTimeout(this.resetTimer);
    this.resetTimer = setTimeout(() => {
      this.classList.remove("is-copied");
      if (this.status) this.status.textContent = "";
    }, 2000);
  }
}
customElements.define("but-copy-code", BUTCopyCode);

// Mobile sticky buy bar (product-sticky-atc.liquid). Main-form nodes are looked up on use, not
// cached: product variations swap the form out from under it.
class BUTStickyAddToCart extends BUTCustomComponent {
  constructor() {
    super();
    this.button = this.$(".js-sticky-atc-button");
    this.buttonText = this.$(".js-sticky-atc-button-text");
    this.stickyForm = this.$(".js-sticky-atc-form");
    this.mobileQuery = window.matchMedia("(max-width: 767px)");
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    this.onQueryChange = this.update.bind(this);
  }

  get mainButton() {
    return document
      .getElementById(this.dataset.formId)
      ?.querySelector(".js-product-form-submit-btn");
  }

  connectedCallback() {
    const section = document.getElementById(this.dataset.section);
    this.buyButtons = section?.querySelector(".product__block-buy_buttons");
    if (!this.buyButtons) return;

    this.button?.addEventListener("click", this.onButtonClick);
    document.addEventListener("change", this.onVariantChange);
    this.mobileQuery.addEventListener("change", this.onQueryChange);

    this.observer = new IntersectionObserver(([entry]) => {
      this.buyButtonsInView = entry.isIntersecting;
      this.update();
    });
    this.observer.observe(this.buyButtons);

    // Disabled state, label and the loading spinner all follow the main button.
    this.buttonObserver = new MutationObserver(() => this.syncButton());
    this.buttonObserver.observe(this.buyButtons, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["disabled", "class"],
    });
    this.syncButton();

    this.resizeObserver = new ResizeObserver(() => {
      document.documentElement.style.setProperty(
        "--sticky-atc-height",
        `${this.offsetHeight}px`
      );
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.button?.removeEventListener("click", this.onButtonClick);
    document.removeEventListener("change", this.onVariantChange);
    this.mobileQuery.removeEventListener("change", this.onQueryChange);
    this.observer?.disconnect();
    this.buttonObserver?.disconnect();
    this.resizeObserver?.disconnect();
  }

  update() {
    const visible = this.mobileQuery.matches && this.buyButtonsInView === false;
    this.classList.toggle("is-visible", visible);
    this.toggleAttribute("inert", !visible);
  }

  syncButton() {
    const mainButton = this.mainButton;
    if (!mainButton || !this.button) return;
    this.button.disabled = mainButton.disabled;
    this.button.classList.toggle(
      "loading",
      mainButton.classList.contains("loading")
    );
    const label = mainButton.querySelector(
      ".js-product-form-submit-btn-text"
    )?.textContent;
    if (label && this.buttonText && this.buttonText.textContent !== label) {
      this.buttonText.textContent = label;
    }
  }

  onButtonClick() {
    this.mainButton?.click();
  }

  // Keeps the sticky form's dynamic checkout button on the selected variant and quantity.
  onVariantChange(event) {
    const form = document.getElementById(this.dataset.formId);
    if (!this.stickyForm || !form) return;
    const target = event.target;
    const isVariantInput =
      target.name === "id" && form.contains(target);
    const isQuantityInput =
      target.name === "quantity" && target.getAttribute("form") === form.id;
    if (!isVariantInput && !isQuantityInput) return;
    const input = this.stickyForm.querySelector(`input[name="${target.name}"]`);
    if (!input || input.value === target.value) return;
    input.value = target.value;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
customElements.define("but-sticky-atc", BUTStickyAddToCart);


class BUTCarouselItem extends BUTCustomComponent {
  constructor() {
    super();
  }

  init() {
    let observe = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          let target = entry.target;

          if (entry.isIntersecting) {
            if (target.dataset.attributePlaceholder === "1") {
              target.setAttribute("aria-hidden", false);
              target.setAttribute("aria-disabled", false);
            }
            observer.unobserve(target);
          }
        });
      },
      {
        root: this.closest("but-carousel"),
        // threshold: 0.1,
      }
    );

    observe.observe(this);
  }
  connectedCallback() {
    this.init();
  }
}

customElements.define("but-carousel-itm", BUTCarouselItem);



class BUTMenuHeader extends BUTCustomComponent {
  constructor() {
    super();
    this.closeTimeout = null;
  }

  connectedCallback() {
    this.init();
    this.handleOnLinkClick();
    if (this.isMegaMenu === false && this.isDesktop) {
      this.initSubmenuPositioning();
    }
    // Add scroll listener to close mega menu
    this.handleScrollEvent();
  }

  initSubmenuPositioning() {
    this.resizeObserver = new ResizeObserver(
      this.checkSubmenuPositions.bind(this)
    );
    this.resizeObserver.observe(document.body);

    this.checkSubmenuPositions();
  }

  checkSubmenuPositions() {
    const dropdowns = this.$$(".menu-dropdown-lv2");

    dropdowns.forEach((dropdown) => {
      const parentItem = dropdown.closest(".menu__item");
      if (!parentItem) return;

      const parentRect = parentItem.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      const spaceRight = viewportWidth - parentRect.right;

      const dropdownWidth = dropdown.offsetWidth;

      const nestedDropdown = dropdown.querySelector(".menu-dropdown-lv3");
      const nestedDropdownWidth = nestedDropdown
        ? nestedDropdown.offsetWidth
        : 0;

      const totalRequiredWidth = dropdownWidth + nestedDropdownWidth;

      dropdown.classList.remove("menu-dropdown--right");

      if (spaceRight <= totalRequiredWidth) {
        dropdown.classList.add("menu-dropdown--right");
      }
    });
  }

  init() {
    this.header = BUTHelper.qs(`but-header`);
    this.triggerBtnElement = BUTHelper.qs(".js-menu-drawer-trigger");
    this.details = this.$("details");
    this.summaries = this.$$("summary");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;
    this.links = this.summary.querySelectorAll(".menu__link__link");
    this.level_one_btn = this.$$(`.js-menu-header-back-btn[data-level="1"]`);
    this.level_two_btn = this.$$(`.js-menu-header-back-btn[data-level="2"]`);
    this.level_third_btn = this.$$(`.js-menu-header-back-btn[data-level="3"]`);
    this.dropdownType = this.header.dataset.menuDropdownOpenType;
    this.overlay = this.$("overlay");
    this.menuOverlay = this.$(".js-menu-overlay");
    this.isMegaMenuShow = false;
    this.isMegaMenu = this.dataset.menuDropdownType === "Megamenu";
    this.isDesktop = window.matchMedia("(min-width: 1195px)").matches;

    this.summaries.forEach((summary) => {
      const details = summary.closest("details");
      summary.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleSummaryClick(event, summary, details);
      });
      summary.addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
    });

    if (this.dropdownType === "hover") {
      this.addHoverEventListeners();
    }
    if (this.menuOverlay) {
      if (
        this.menuOverlay.clientHeight <
        this.menuOverlay.querySelector(".megamenu-container").clientHeight
      ) {
        this.overlay.classList.add("menu-overlay");
      } else {
        this.overlay.classList.remove("menu-overlay");
      }
      this.menuOverlay.addEventListener("scroll", () => {
        if (
          Math.ceil(
            this.menuOverlay.scrollTop + this.menuOverlay.clientHeight
          ) >= this.menuOverlay.scrollHeight
        ) {
          this.overlay.classList.remove("menu-overlay");
        } else {
          this.overlay.classList.add("menu-overlay");
        }
      });
    }

    this.bindEventHandlers();
  }

  handleMegamenuContainerOverlay() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.overlay?.classList.remove("menu-overlay");
          }
        });
      },
      {
        threshold: 1,
      }
    );
    observer.observe(this.menuOverlay?.querySelector(".js-megamenu-container"));
  }

  handleSummaryClick(event, summary, details) {
    if (this.menuOverlay?.querySelector(".js-megamenu-container")) {
      this.handleMegamenuContainerOverlay();
    }
    const megaMenu = details.querySelector(".js-mega-menu-wrapper");
    let megaMenuType = "";
    const isLevelOne = details.dataset.level === "1";
    const isLevelTwo = details.dataset.level === "2";
    event.currentTarget.setAttribute("aria-expanded", !details.open);
    if (megaMenu) {
      megaMenuType = megaMenu.dataset.megaMenuType;
    }
    if (isLevelOne || isLevelTwo) {
      this.summaries.forEach((otherSummary) => {
        const otherDetails = otherSummary.closest("details");
        if (otherDetails.dataset.level === "2" && otherDetails !== details) {
          otherDetails.classList.remove("is-open");
          setTimeout(() => {
            otherDetails.open = false;
          }, 100);
        }
      });
    }

    if (isLevelOne) {
      this.closeAllMenu();
      if (megaMenuType !== "drawer") {
        event.stopPropagation();
      }
    }
    if (!details.hasAttribute("open") && !this.menuOpen) {
      this.open();
      details.open = true;
      setTimeout(() => {
        details.classList.add("is-open");
        const dropdown = details.querySelector(".js-header-menu-wrapper");
        if (dropdown) {
          void dropdown.offsetHeight;
          dropdown.classList.remove("animated-out", "animated");
          document.body.classList.remove("animated-out", "animated");
          dropdown.classList.add("animated");
          document.body.classList.add("animated");
        }
        if (!this.isMegaMenu && this.isDesktop) {
          this.checkSubmenuPositions();
        }
      }, 0);
      document.body.classList.toggle(
        "is-megamenu-show",
        this.dataset.menuDropdownType === "Megamenu"
      );
    } else {
      const dropdown = details.querySelector(".js-header-menu-wrapper");
      if (dropdown) {
        void dropdown.offsetHeight;
        dropdown.classList.remove("animated");
        dropdown.classList.add("animated-out");
        document.body.classList.add("animated-out");
        document.body.classList.remove("animated");
        setTimeout(() => {
          dropdown.classList.remove("animated-out");
          document.body.classList.remove(
            "animated-out",
            "animated",
            "is-megamenu-show"
          );
          summary.setAttribute("aria-expanded", false);
          details.classList.remove("is-open");
          details.open = false;
        }, 300);
      }
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    // Remove scroll event listener
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
  }

  addHoverEventListeners() {
    this.summaries.forEach((summary) => {
      if (!summary.closest("but-header")) return;
      const details = summary.closest("details");
      const megaMenu = details.querySelector(".js-mega-menu-wrapper");
      ["mouseenter", "mouseleave"].forEach((event) => {
        details.addEventListener(event, this.onHandleMouseEvent.bind(this));
        if (megaMenu) {
          megaMenu.addEventListener(event, this.onHandleMouseEvent.bind(this));
        }
      });
    });
  }

  bindEventHandlers() {
    // Common event handler function for both level_one_btn and level_two_btn
    const handleClick = (el) => {
      const details = el.currentTarget.closest("details");
      const summary = details.querySelector("summary:first-child");
      summary.setAttribute("aria-expanded", !details.open);
      if (details.hasAttribute("open")) {
        // Trigger slide-out by removing the open-state class first
        details.classList.toggle("is-open", !details.open);

        // Wait for the submenu translateX transition to complete before closing <details>
        const panel =
          details.querySelector(
            ".menu-dropdown-lv3, .menu-dropdown-lv2, .menu-dropdown, .menu-drawer-lv3"
          ) || details.querySelector(".js-header-menu-wrapper");

        let closed = false;
        const finishClose = () => {
          if (closed) return;
          closed = true;
          details.open = false;
        };

        const onEnd = (e) => {
          if (e.propertyName === "transform") {
            panel?.removeEventListener("transitionend", onEnd);
            finishClose();
          }
        };

        if (panel) {
          panel.addEventListener("transitionend", onEnd, { once: true });
        }
        // Fallback in case transitionend doesn't fire
        setTimeout(finishClose, 500);

        if (details.dataset.level === "1") {
          this.header.classList.remove("header-menu--open");
          this.menu_body_drawer?.classList.remove("menu--is-open");
        }
        summary.focus();
      }
    };

    // Bind click event handlers to both level_one_btn and level_two_btn
    [
      ...this.level_one_btn,
      ...this.level_two_btn,
      ...this.level_third_btn,
    ].forEach((e) => {
      e.addEventListener("click", handleClick);
    });
  }
  handleOnLinkClick() {
    this.links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    });
  }

  handleScrollEvent() {
    // Create a throttled scroll handler to improve performance
    let isScrolling = false;

    this.scrollHandler = () => {
      if (!isScrolling) {
        window.requestAnimationFrame(() => {
          document.body.classList.remove("is-megamenu-show");

          // Close all open details
          const openDetails = this.$$("details[open]");
          openDetails.forEach((details) => {
            const dropdown = details.querySelector(".js-header-menu-wrapper");
            const summary = details.querySelector("summary");

            if (dropdown) {
              dropdown.classList.remove("animated");
              dropdown.classList.add("animated-out");
              setTimeout(() => {
                dropdown.classList.remove("animated-out");
                details.classList.remove("is-open");
                details.open = false;
                if (summary) {
                  summary.setAttribute("aria-expanded", false);
                }
              }, 300);
            }
          });

          // Clear any pending close timeouts
          if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
            this.closeTimeout = null;
          }

          isScrolling = false;
        });
        isScrolling = true;
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", this.scrollHandler, { passive: true });
  }

  onHandleMouseEvent(event) {
    const details = this.querySelector("details");
    const megaMenu = details.querySelector(".js-mega-menu-wrapper");
    let megaMenuType = "";
    let detailLevel = event.target.closest("details").dataset.level;
    if (megaMenu) {
      megaMenuType = megaMenu.dataset.megaMenuType;
    }
    if (megaMenuType === "drawer") {
      const summary = megaMenu.closest("details").querySelector("summary");
      const link = summary.querySelector(".js-menu-link");
      const link_title = summary.querySelector(".js-menu-link-title");
      link.classList.replace("d-block", "d-none");
      link_title.classList.replace("d-none", "d-block");
    }
    if (
      megaMenu &&
      event.relatedTarget &&
      event.type === "mouseleave" &&
      (details.contains(event.relatedTarget) ||
        megaMenu.contains(event.relatedTarget))
    ) {
      return;
    }

    if (!megaMenu && detailLevel === "2") {
      const detailsLevel2 = event.target.closest("details");
      this.handleDetailsMouseEvent(
        event,
        detailsLevel2,
        megaMenuType,
        megaMenu
      );
    }
    this.handleDetailsMouseEvent(event, details, megaMenuType, megaMenu);
    if (this.menuOverlay?.querySelector(".js-megamenu-container")) {
      this.handleMegamenuContainerOverlay();
    }
  }

  handleDetailsMouseEvent(event, details, megaMenuType, megaMenu) {
    if (event.type == "mouseenter" && megaMenuType !== "drawer") {
      this.toggleMenu(true, details);
    } else if (
      event.type == "mouseleave" &&
      !details.contains(event.relatedTarget) &&
      !megaMenu?.contains(event.relatedTarget) &&
      megaMenuType !== "drawer"
    ) {
      this.toggleMenu(false, details);
    }
  }

  toggleMenu(open, details) {
    this.isMegaMenuShow = open;
    const dropdown = details.querySelector(".js-header-menu-wrapper");
    let summary = details.querySelector("summary");

    if (open) {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
      }
      this.closeAllMenu();
      if (dropdown) void dropdown.offsetHeight;

      details.classList.add("is-open");
      details.open = true;
      summary.setAttribute("aria-expanded", true);

      if (dropdown) {
        dropdown.classList.remove("animated-out");
        document.body.classList.remove("animated-out");
        dropdown.classList.add("animated");
        document.body.classList.add("animated");
      }

      document.body.classList.toggle(
        "is-megamenu-show",
        this.dataset.menuDropdownType === "Megamenu"
      );
    } else {
      if (dropdown) {
        void dropdown.offsetHeight;
        dropdown.classList.remove("animated");
        dropdown.classList.add("animated-out");
        document.body.classList.add("animated-out");
        document.body.classList.remove("animated");
        this.closeTimeout = setTimeout(() => {
          dropdown.classList.remove("animated-out");
          document.body.classList.remove("animated-out");
          details.classList.remove("is-open");
          details.open = false;
          summary.setAttribute("aria-expanded", false);
          const megaMenus = document.querySelectorAll("details");
          const isAnyHovered = Array.from(megaMenus).some((menu) => {
            const dataType = menu.querySelector(".js-mega-menu-wrapper")
              ?.dataset.megaMenuType;
            return dataType === "drawer" ? false : menu.matches(":hover");
          });
          if (!isAnyHovered && !this.isMegaMenuShow) {
            document.body.classList.remove("is-megamenu-show");
          }
        }, 300);
      }
    }
  }

  closeAllMenu() {
    let allSummaries = BUTHelper.qsa("but-menu-header summary");
    let allDetails = Array.from(
      BUTHelper.qsa("but-menu-header details")
    ).filter((detail) => {
      return !this.contains(detail);
    });
    allSummaries.forEach((summary) => {
      summary.setAttribute("aria-expanded", false);
    });
    allDetails.forEach((details) => {
      const dropdown = details.querySelector(".js-header-menu-wrapper");
      if (dropdown) {
        dropdown.classList.remove("animated");
        dropdown.classList.add("animated-out");
        setTimeout(() => dropdown.classList.remove("animated-out"), 300);
      }
      details.classList.toggle("is-open", false);
      details.open = false;
    });
  }

  onKeyUpEscEvent(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    let openedDetails = event.target.closest("details[open]");
    if (!openedDetails) return;
    const dropdown = openedDetails.querySelector(".js-header-menu-wrapper");
    if (dropdown) {
      dropdown.classList.remove("animated");
      dropdown.classList.add("animated-out");
      setTimeout(() => dropdown.classList.remove("animated-out"), 300);
    }
    document.body.removeEventListener("click", this.onBodyClick);
    let summary = openedDetails.querySelector("summary");
    if (openedDetails.dataset.level == "1") {
      if (!openedDetails.hasAttribute("open")) {
        this.header.classList.add("header-menu--open");
        this.menu_body_drawer?.classList.add("menu--is-open");
      } else {
        this.header.classList.remove("header-menu--open");
        this.menu_body_drawer?.classList.remove("menu--is-open");
      }
    }
    openedDetails.classList.remove("is-open");
    this.menu_body_drawer?.classList.remove("menu--is-open");
    setTimeout(() => {
      openedDetails.removeAttribute("open");
      summary.setAttribute("aria-expanded", false);
    }, 100);
    summary.focus();
  }

  close() {
    document.body.removeEventListener("click", this.handleBodyClick.bind(this));
    document.body.classList.remove("is-megamenu-show");

    if (this.details.dataset.level == "1") {
      if (this.details.hasAttribute("open")) {
        this.header.classList.remove("header-menu--open");
        this.menu_body_drawer?.classList.remove("menu--is-open");
      }
    }

    for (let i = 0, n = this.summaries.length; i < n; i++) {
      let summary = this.summaries[i];
      let details = summary.closest("details");
      const dropdown = details.querySelector(".js-header-menu-wrapper");
      if (dropdown) {
        dropdown.classList.remove("animated");
        dropdown.classList.add("animated-out");
        setTimeout(() => dropdown.classList.remove("animated-out"), 300);
      }
      details.classList.remove("is-open");
      setTimeout(() => {
        details.removeAttribute("open");
        summary.setAttribute("aria-expanded", false);
      }, 100);
    }
  }

  open() {
    document.body.addEventListener("click", this.handleBodyClick.bind(this));
  }

  handleBodyClick(event) {
    if (!this.contains(event.target)) this.close();
  }
}
customElements.define("but-menu-header", BUTMenuHeader);

class BUTMenuDrawer extends BUTCoreDrawer {
  constructor() {
    super();
  }
  connectedCallback() {
    this.handleBindEvents();
  }
  handleBindEvents() {
    const button = BUTHelper.qs("but-menu-drwer-opner");
    button.addEventListener("click", () => {
      this.summaries = this.querySelectorAll("summary");
      this.level_one_btn = this.querySelectorAll(
        `.js-menu-header-back-btn[data-level="1"]`
      );
      this.summaries.forEach((summary) => {
        const details = summary.closest("details");
        summary.addEventListener("click", (event) => {
          event.preventDefault();
          this.handleSummaryMobileClick(event, details);
        });
      });
      const handleClick = () => {
        const headerNav = BUTHelper.qsa(".js-header-navigation");
        headerNav.forEach((nav) => {
          // Only remove d-none-important from drawer menus
          if (nav.closest('.menu-drawer-wrapper')) {
            nav.classList.remove("d-none-important");
          }
        });
      };
      this.level_one_btn.forEach((e) => {
        e.addEventListener("click", handleClick);
      });
    });
  }

  handleSummaryMobileClick(event, details) {
    if (details.dataset.level === "1") {
      const headerNav = BUTHelper.qsa(".js-header-navigation");
      const currentHeaderNav = event.target.closest(".js-header-navigation");
      headerNav.forEach((nav) => {
        // Only hide drawer menus, not horizontal menus
        if (nav !== currentHeaderNav && nav.closest('.menu-drawer-wrapper')) {
          nav.classList.add("d-none-important");
        }
      });
    }
  }
}

customElements.define("but-menu-drwer", BUTMenuDrawer);

class BUTMenuDrawerOpener extends BUTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.triggerBtnElement = this.$(".js-menu-drawer-trigger");
    this.menuDrawerElement = BUTHelper.qs("but-menu-drwer");
    this.triggerBtnElement.addEventListener("click", (e) => {
      setTimeout(() => {
        this.menuDrawerElement.openDrawer(e.target);
      }, 0);
    });
  }
}

customElements.define("but-menu-drwer-opner", BUTMenuDrawerOpener);

class BUTStickyHeader extends BUTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.butHeaderElement = this.querySelector(".js-header");
    this.prodGridSection = BUTHelper.qs(".js-product-grid-section");
    this.header = BUTHelper.qs(".js-section-header");
    this.stickyProductGrid = BUTHelper.qs("but-sticky-prodrid");
    this.sticky_state = this.dataset.stickyState;
    this.colorSchemaDefault = this.butHeaderElement.dataset.color;
    this.colorSchemaSticky = this.butHeaderElement.dataset.colorSticky;
    this.originalHeaderPosition = this.header.offsetTop;
    this.boundingBottom =
      this.butHeaderElement.offsetHeight + this.originalHeaderPosition;
    this.previousScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;
    this.currentScrollTop = 0;
    this.isHeaderHidden = false;
    this.isSticky = false;
    this.prevent_reveal = false;
    this.headerBounds = {};
    if (this.stickyProductGrid) {
      window.customElements.whenDefined("but-sticky-prodrid").then(() => {
        this.stickyProductGrid.init();
      });
    }
    this.updateHeaderHeight();
    this.bindEventHandlers();
    this.createObserver();
  }

  updateHeaderHeight() {
    BUTHelper.qde.style.setProperty(
      "--header-height",
      `${this.header.offsetHeight}px`
    );
  }

  connectedCallback() {
    this.init();
  }

  bindEventHandlers() {
    if (this.sticky_state == "false") return false;
    this.preventStickyHeaderReveal = () => (this.prevent_reveal = true);
    this.addEventListener(
      "preventStickyHeaderReveal",
      this.preventStickyHeaderReveal
    );
    window.addEventListener("scroll", this.onScrollHandle.bind(this), false);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.header_bounds = entries[0].intersectionRect;

      observer.disconnect();
    });

    observer.observe(this.header);
  }

  setSchemeSticky() {
    this.butHeaderElement.classList.remove(this.colorSchemaDefault);
    this.butHeaderElement.classList.add(this.colorSchemaSticky);
  }

  setSchemeDefault() {
    this.butHeaderElement.classList.remove(this.colorSchemaSticky);
    this.butHeaderElement.classList.add(this.colorSchemaDefault);
  }

  onScrollHandle() {
    this.currentScrollTop = window.pageYOffset || BUTHelper.qde.scrollTop;
    if (this.sticky_state == "always_reveal") {
      if (this.currentScrollTop > this.originalHeaderPosition) {
        this.isSticky = true;
        this.header.classList.add("header--sticky");
        this.setSchemeSticky();
        this.prodGridSection?.style.setProperty(
          "--sticky-header-height",
          `${this.butHeaderElement.offsetHeight}px`
        );
      } else {
        this.isSticky = false;
        this.header.classList.remove("header--sticky");
        this.setSchemeDefault();
      }
      return;
    }

    if (!this.header_bounds) return;

    if (this.boundingBottom <= this.currentScrollTop) {
      this.hideHeader();
    }

    if (
      this.currentScrollTop > this.previousScrollTop &&
      !this.isHeaderHidden &&
      this.currentScrollTop > this.originalHeaderPosition
    ) {
      this.hideHeader();
    }

    // If scrolling up, show the header
    if (this.currentScrollTop < this.previousScrollTop && this.isHeaderHidden) {
      this.showHeader();
    }
    if (this.currentScrollTop > this.boundingBottom && !this.isSticky) {
      this.header.classList.add("header--fixed");
      this.setSchemeSticky();
      this.isSticky = true;
    }
    if (
      (this.currentScrollTop < this.originalHeaderPosition && this.isSticky) ||
      this.currentScrollTop == 0
    ) {
      this.header.classList.remove("header--fixed");
      this.header.classList.remove("header--hidden", "header--visible");
      this.setSchemeDefault();
      this.isSticky = false;
    }
    this.previousScrollTop = this.currentScrollTop;
  }
  showHeader() {
    this.header.classList.add("header--visible");
    this.header.classList.remove("header--hidden");
    this.setSchemeSticky();
    this.isHeaderHidden = false;
  }
  hideHeader() {
    this.header.classList.add("header--hidden");
    this.header.classList.remove("header--visible");
    this.isHeaderHidden = true;
    this.closeMenu();
  }

  closeMenu() {
    this.menus = this.header.querySelectorAll("but-menu-header");
    this.menus.forEach((menu) => menu.close());
  }

  disconnectedCallback() {
    this.removeEventListener(
      "preventStickyHeaderReveal",
      this.preventStickyHeaderReveal
    );
    window.removeEventListener("scroll", this.onScrollHandle.bind(this));
  }
}
customElements.define("but-header-sticky", BUTStickyHeader);
class BUTHeader extends BUTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.btnSearchs = BUTHelper.qsa(".js-search-open-trigger");
    this.predictiveSearchDrawer = BUTHelper.qs("but-search-drwr-section");
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.btnSearchs.forEach((btn) => {
      btn.addEventListener("click", (e) => this.onBtnSearchClick(e, btn));
    });
    window.addEventListener("resize", () => {
      this.closeAllMenu();
      if (!window.matchMedia("(max-width: 1024px)").matches) {
        const headerNav = BUTHelper.qsa(".js-header-navigation");
        headerNav.forEach((nav) => {
          // Only remove d-none-important from drawer menus
          if (nav.closest('.menu-drawer-wrapper')) {
            nav.classList.remove("d-none-important");
          }
        });
      }
    });
  }

  closeAllMenu() {
    let allSummaries = this.$$("summary");
    let allDetails = this.$$("details");
    allSummaries.forEach((summary) => {
      summary.setAttribute("aria-expanded", false);
    });
    allDetails.forEach((details) => {
      details.classList.toggle("is-open", false);
      details.open = false;
    });
    document.body.classList.remove(...["o-hidden"]);
  }

  onBtnSearchClick(event, btn) {
    if (btn?.dataset.event != "page") {
      event.preventDefault();
      this.predictiveSearchDrawer.openDrawer(event.target);
      setTimeout(() => {
        BUTHelper.trapFocus(
          this.predictiveSearchDrawer,
          this.predictiveSearchDrawer.querySelector(
            ".js-predictive-search-input"
          )
        );
      }, 650);
    }
  }
}
// Register to the Browser from `customElements` API
customElements.define("but-header", BUTHeader);
class BUTStickyProdGrid extends BUTCustomComponent {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.stickyHeaderState =
      BUTHelper.qs("but-header-sticky")?.dataset.stickyState;
    this.onScrollHandle = this.onScrollHandle.bind(this);
    this.stickyBarPotition = this.offsetTop;
    this.stickyHeight = this.offsetHeight;
    this.prodGridSection = BUTHelper.qs(".js-product-grid-section");
    this.prodGridSection?.style.setProperty(
      "--prductgrid-bar-height",
      `${this.stickyHeight}px`
    );
    this.headerHeight = BUTHelper.qs(".js-section-header")?.offsetHeight;
    this.prodgridToTop = this.stickyBarPotition - this.headerHeight;
    this.bindEventHandlers();
  }
  bindEventHandlers() {
    window.addEventListener("scroll", this.onScrollHandle, false);
  }

  onScrollHandle() {
    const scrollTop = window.pageYOffset || BUTHelper.qde.scrollTop;
    const hasStickyBarClass = this.classList.contains(
      "product-grid-sticky-bar"
    );
    const hasAlwaysRevealClass = this.classList.contains(
      "always_reveal--sticky"
    );

    if (this.stickyHeaderState === "always_reveal") {
      if (scrollTop > this.prodgridToTop && !hasAlwaysRevealClass) {
        this.classList.add("always_reveal--sticky");
      } else if (scrollTop <= this.prodgridToTop && hasAlwaysRevealClass) {
        this.classList.remove("always_reveal--sticky");
      }
    } else {
      if (scrollTop > this.stickyBarPotition && !hasStickyBarClass) {
        this.classList.add("product-grid-sticky-bar");
      } else if (scrollTop <= this.stickyBarPotition && hasStickyBarClass) {
        this.classList.remove("product-grid-sticky-bar");
      }
    }
  }
}
customElements.define("but-sticky-prodrid", BUTStickyProdGrid);


class BUTTabOverflow extends BUTCustomComponent {
  constructor() {
    super();
    this.tabContainer = this.$(".js-tab-container");
    this.tabOverflow = this.$(".js-tab-overflow");
    this.tabLinks = this.$$(".js-tab-link");
    this.tabStyle = this.getAttribute("data-tab-style");
    this.tabAnimation = this.initTabAnimation();
    this.activeTabLink = this.initActiveTab();
    this.bindEventHandlers();
  }

  connectedCallback() {
    this.updateOverFlow();
    this.updateIndicator(this.activeTabLink);
  }

  initTabAnimation() {
    let tabAnimation = this.tabContainer.querySelector(
      ".tab-animated-underline, .tab-animated-solid"
    );
    if (!tabAnimation) {
      tabAnimation = document.createElement("div");
      tabAnimation.className =
        {
          underline: "tab-animated-underline",
          solid: "tab-animated-solid",
        }[this.tabStyle] || "";
      this.tabContainer.appendChild(tabAnimation);
    }
    return tabAnimation;
  }

  initActiveTab() {
    const activeTab =
      this.tabContainer.querySelector(".js-tab-link.tab__link--active") ||
      this.tabLinks[0];
    if (activeTab) {
      activeTab.classList.add("tab__link--active");
      activeTab.style.background = this.tabStyle ? "transparent" : "";
    }
    return activeTab;
  }

  bindEventHandlers() {
    this.tabContainer.addEventListener("scroll", () => this.updateOverFlow());
    window.addEventListener("resize", () => {
      this.updateOverFlow();
      this.updateIndicator(this.activeTabLink);
    });

    this.tabContainer.addEventListener("click", (event) => {
      const clickedTab = event.target.closest(".js-tab-link");
      if (clickedTab) {
        this.tabLinks.forEach((tab) => {
          tab.classList.remove("tab__link--active");
          tab.style.background = "";
        });
        clickedTab.classList.add("tab__link--active");
        clickedTab.style.background = this.tabStyle ? "transparent" : "";
        this.updateIndicator(clickedTab);
      }
    });
  }

  updateOverFlow() {
    const { scrollWidth, clientWidth, scrollLeft } = this.tabContainer;
    const isScrollable = scrollWidth > clientWidth;
    const maxScrollLeft = scrollWidth - clientWidth - 1;

    if (!isScrollable) {
      this.tabOverflow?.classList.remove(
        "tab-overflow--right",
        "tab-overflow--left"
      );
      return;
    }
    this.tabOverflow?.classList.toggle("tab-overflow--left", scrollLeft > 0);
    this.tabOverflow?.classList.toggle(
      "tab-overflow--right",
      scrollLeft < maxScrollLeft
    );
  }

  updateIndicator(activeTab) {
    if (
      !activeTab ||
      (this.tabStyle !== "underline" && this.tabStyle !== "solid")
    )
      return;
    Object.assign(this.tabAnimation.style, {
      width: `${activeTab.offsetWidth}px`,
      left: `${activeTab.offsetLeft}px`,
      display: "block",
    });
  }
}
customElements.define("but-tab-overflow", BUTTabOverflow);

class BUTSelectSectionInEditor extends BUTCoreDrawer {
  constructor(elementSelect, key) {
    super();
    this.elementSelect = elementSelect;
    this.key = key;
    this.bindEventSelectHandlers();
  }

  bindEventSelectHandlers() {
    const elementSection = BUTHelper.qs(this.elementSelect);
    if (typeof Shopify === "undefined" || !Shopify.designMode) return;

    const handleSectionEvent = (event) => {
      const isTargetSection = event.detail.sectionId.includes(this.key);
      elementSection.toggleAttribute(
        "open",
        isTargetSection && event.type === "shopify:section:select"
      );
    };

    document.addEventListener("shopify:section:select", handleSectionEvent);
    document.addEventListener("shopify:section:deselect", handleSectionEvent);
  }
}

class BUTSearchDrawerInEditor extends BUTSelectSectionInEditor {
  constructor() {
    super("but-search-drwr-section", "search_drawer");
  }
}
customElements.define("but-search-drwr-section", BUTSearchDrawerInEditor);

class BUTCartDrawer extends BUTSelectSectionInEditor {
  static relatedSwiper = null;
  constructor() {
    super("but-cart-drwr", "cart_drawer");
    this.swiperInstance = null;
    this.initSwiper();
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        space_selector: `#cartDrawer`,
      },
    ];
  }
  initSwiper() {
    if (typeof Swiper === 'undefined') {
      // Wait for Swiper to load
      const checkSwiper = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          this.initSwiper();
        }
      }, 100);
      return;
    }

    const swiperContainer = this.$('.swiper');
    if (!swiperContainer) return;

    // Destroy existing instance if any
    if (this.swiperInstance) {
      try {
        this.swiperInstance.destroy(true, true);
      } catch (e) {
        console.error("Error destroying existing Swiper:", e);
      }
    }

    BUTCartDrawer.relatedSwiper = this.querySelector('.drawer__related-products-list').innerHTML;

    // Get navigation buttons
    const prevBtn = this.$('.js-variation-swiper-prev-btn');
    const nextBtn = this.$('.js-variation-swiper-next-btn');

    // Initialize Swiper
    this.swiperInstance = new Swiper(swiperContainer, {
      slidesPerView: 2,
      spaceBetween: 4,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn || undefined,
        prevEl: prevBtn || undefined,
        disabledClass: 'is-disabled',
        hiddenClass: 'is-hidden',
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 16,
          slidesOffsetAfter: 40,
        }
      },
      on: {
        init: () => this.updateNavigationButtons(),
        slideChange: () => this.updateNavigationButtons(),
      },
    });
  }

  updateSwiperOpened() {
    // Rebuilding the related-products carousel rewrites innerHTML and then has
    // Swiper measure the result. Done synchronously it lands mid-slide and
    // costs frames, so hold it until the drawer has settled; callers that fire
    // repeatedly (a cart update, then the drawer opening) collapse into one.
    if (this._swiperBuildQueued) return;
    this._swiperBuildQueued = true;
    this.animationsSettled().then(() => {
      this._swiperBuildQueued = false;
      this.buildRelatedSwiper();
    });
  }

  buildRelatedSwiper() {
    // The previous instance keeps resize/scroll observers alive on DOM that is
    // about to be replaced; each leaked one makes later opens heavier.
    this.swiperInstance?.destroy(true, false);
    this.swiperInstance = null;
    const relatedList = this.querySelector('.drawer__related-products-list');
    if (relatedList) relatedList.innerHTML = BUTCartDrawer.relatedSwiper;
    const swiperContainer = this.$('.swiper');
    if (!swiperContainer) return;
    // Get navigation buttons
    const prevBtn = this.$('.js-variation-swiper-prev-btn');
    const nextBtn = this.$('.js-variation-swiper-next-btn');

    // Initialize Swiper
    this.swiperInstance = new Swiper(swiperContainer, {
      slidesPerView: 2,
      spaceBetween: 4,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn || undefined,
        prevEl: prevBtn || undefined,
        disabledClass: 'is-disabled',
        hiddenClass: 'is-hidden',
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 16,
          slidesOffsetAfter: 40,
        }
      },
      on: {
        init: () => this.updateNavigationButtons(),
        slideChange: () => this.updateNavigationButtons(),
      },
    });

  }

  updateNavigationButtons() {
    if (!this.swiperInstance) return;
    const prevBtn = this.$('.js-variation-swiper-prev-btn');
    const nextBtn = this.$('.js-variation-swiper-next-btn');

    if (prevBtn) {
      if (this.swiperInstance.isBeginning) {
        prevBtn.classList.add('is-disabled');
      } else {
        prevBtn.classList.remove('is-disabled');
      }
    }

    if (nextBtn) {
      if (this.swiperInstance.isEnd) {
        nextBtn.classList.add('is-disabled');
      } else {
        nextBtn.classList.remove('is-disabled');
      }
    }
  }
}
customElements.define("but-cart-drwr", BUTCartDrawer);

document.addEventListener("DOMContentLoaded", () => {
  const searchBtn = BUTHelper.qsa(".js-search-open-trigger");
  const searchSection = BUTHelper.qs("but-search-drwr-section");
  if (!searchSection) {
    searchBtn.forEach((btn) => {
      if (btn.dataset.event === "drawer") {
        if (typeof Shopify !== "undefined" && Shopify.designMode) {
          btn.addEventListener("click", () => {
            setTimeout(() => {
              alert(
                "Search is unavailable due to a conflict in the search settings. Please unhide the ‘Search Drawer’ section or change the search behavior to ‘Search Page’ to resolve this issue. This message is only visible in the theme editor. In the live store, the system will automatically default to the ‘Search Page’."
              );
            }, 500);
          });
        } else {
          btn.removeAttribute("onclick");
        }
      }
    });
  }
});

class BUTPopoverNoti extends BUTCustomComponent {
  constructor() {
    super();
    this.iconCancel = this.$(".js-icon-cancel");
    this.notificationNewsletter = BUTHelper.qs(".js-newsletter-notification");
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.renderNotificationNewsletter();
    this.bindEventHandlers();
    this.autoHide();
  }

  togglePanel(toggle) {
    if (toggle) {
      this.notificationNewsletter.classList.add("show");
    } else {
      this.notificationNewsletter.classList.remove("show");
    }
    return;
  }

  renderNotificationNewsletter() {
    this.notificationNewsletter.innerHTML = this.innerHTML;
    this.togglePanel(true);
  }

  bindEventHandlers() {
    this.iconCancel.addEventListener("click", () => {
      this.togglePanel(false);
    });
  }

  autoHide() {
    setTimeout(() => {
      this.togglePanel(false);
    }, 3000);
  }
}

customElements.define("but-noti", BUTPopoverNoti);



class BUTLoadMedia extends BUTCustomComponent {
  constructor() {
    super();
    this.sectionID = this.dataset.sectionId;
    this.idVideo = this.dataset.idVideo;
    this.typeVideo = this.dataset.type;
    this.muteVideo = this.dataset.muteVideo;
    this.eleVideo = this.$(".js-video-media-item")?.id;
    this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this);
    this.onPlayerPlay = this.onPlayerPlay.bind(this);
    this.trigger = this.$(".js-load-media-trigger");
    this.isVideoReady = false;
    this.isLoadingStarted = false;
    if (this.trigger) {
      this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));
    }
  }

  handlePlayVideo() {
    // Prevent multiple clicks while loading
    if (this.isLoadingStarted) return;
    this.isLoadingStarted = true;

    // Add loading state to trigger
    this.trigger?.classList.add("loading");

    this.loadContent();
    const video = this.querySelector(".js-media-item-video");
    if (video) {
      video.addEventListener("play", () => {
        this.pauseAllVideo(video);
        video.play();
      });
    }
  }

  onYouTubeIframeAPIReady() {
    if (typeof YT !== "undefined" && typeof YT.Player !== "undefined") {
      try {
        this.player = new YT.Player(this.eleVideo, {
          videoId: this.idVideo,
          playerVars: {
            playsinline: 1,
            autoplay: 1,
            mute: this.muteVideo,
          },
          events: {
            onReady: this.onPlayerYTReady,
            onStateChange: this.onPlayerStateYTChange,
          },
        });
      } catch (error) {
        console.error("Error when creating the Youtube player:", error);
        this.handleVideoLoadError();
      }
    } else {
      let tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      tag.onload = () => {
        this.onYouTubeIframeAPIReady();
      };
      tag.onerror = () => {
        this.handleVideoLoadError();
      };
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  onVimeoIframeAPIReady() {
    if (typeof Vimeo !== "undefined" && typeof Vimeo.Player !== "undefined") {
      try {
        const options = {
          id: this.idVideo,
          autoplay: 1,
        };

        this.playerVimeo = new Vimeo.Player(this.eleVideo, options);

        // Wait for player to be ready
        this.playerVimeo
          .ready()
          .then(() => {
            this.onPlayerVimeoReady();
          })
          .catch((error) => {
            console.error("Error when Vimeo player ready:", error);
            this.handleVideoLoadError();
          });

        if (this.playerVimeo.element !== "iframe") {
          this.querySelector(".js-vimeo-media").classList.remove("d-none");
        } else {
          this.querySelector(".js-vimeo-media").classList.add("d-none");
        }

        this.playerVimeo.on("play", () => {
          this.pauseAllVideo(this.playerVimeo);
        });
      } catch (error) {
        console.error("Error when creating the Vimeo player:", error);
        this.handleVideoLoadError();
      }
    } else {
      let tag = document.createElement("script");
      tag.src = "https://player.vimeo.com/api/player.js";
      tag.onload = () => {
        this.onVimeoIframeAPIReady();
      };
      tag.onerror = () => {
        this.handleVideoLoadError();
      };
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  onPlayerYTReady = () => {
    this.isVideoReady = true;
    this.hideThumbAndShowVideo();
    this.pauseAllVideo(this.player);
    this.player.playVideo();
  };

  onPlayerVimeoReady = () => {
    this.isVideoReady = true;
    this.hideThumbAndShowVideo();
    this.pauseAllVideo(this.playerVimeo);
  };

  onPlayerStateYTChange = (event) => {
    if (event.data == 1) {
      this.onPlayerPlay();
    }
  };

  onPlayerPlay = () => {
    this.pauseAllVideo(this.player);
  };

  hideThumbAndShowVideo() {
    // Only hide thumbnail when video is ready
    if (this.isVideoReady) {
      this.trigger?.classList.add("d-none-important");
      this.trigger?.classList.remove("loading");
      this.$(".js-media-item")?.classList.add("d-flex");
    }
  }

  handleVideoLoadError() {
    // Reset loading state and show error or fallback
    this.isLoadingStarted = false;
    this.trigger?.classList.remove("loading");
    console.error("Failed to load video player");
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      if (this.$("template")) {
        let template =
          this.$("template").content.firstElementChild.cloneNode(true);
        this.appendChild(template);
        this.isLoaded(true);
        this.isVideoReady = true;
        this.hideThumbAndShowVideo();
      } else {
        if (this.typeVideo == "youtube") {
          this.onYouTubeIframeAPIReady();
        } else if (this.typeVideo == "vimeo") {
          this.onVimeoIframeAPIReady();
        } else {
          this.isVideoReady = true;
          this.hideThumbAndShowVideo();
          return true;
        }
      }
      return true;
    }
  }

  pauseAllVideo(currentVideo) {
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='youtube']"
    ).forEach((video) => {
      if (video.player && currentVideo !== video.player) {
        video.player?.pauseVideo();
      }
    });
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='vimeo'])"
    ).forEach((video) => {
      if (video.playerVimeo !== currentVideo) {
        video.playerVimeo?.pause();
      }
    });
    BUTHelper.qsa(".js-media-item-video").forEach((video) => {
      if (video !== currentVideo) {
        video.pause();
      }
    });
  }

  isLoaded(loaded) {
    if (loaded) {
      this.setAttribute("loaded", true);
    } else {
      this.removeAttribute("loaded");
    }
  }
}

customElements.define("but-load-media", BUTLoadMedia);


class BUTVideoBanner extends BUTCustomComponent {
  constructor() {
    super();
    this.iframe = this.$("iframe");
    this.isPlaying = JSON.parse(this.dataset.videoPlay);
    this.isMute = JSON.parse(this.dataset.videoMute);

    this.btnPlay = this.$(".js-btn-play");
    this.btnMute = this.$(".js-btn-mute");
    this.local_video = this.$("video");

    if (this.btnPlay) {
      this.bindEventHandlers();
    }
  }

  connectedCallback() {
    this.execute();
    if (typeof Shopify !== "undefined" && Shopify.designMode) {
      this.querySelector(".js-btn-mute")?.classList.add("pe-none");
    } else {
      this.querySelector(".js-btn-mute")?.classList.remove("pe-none");
    }
  }

  bindEventHandlers() {
    this.btnPlay.addEventListener("click", () => {
      this.togglePlay();
    });
    this.btnMute.addEventListener("click", () => {
      this.toggleMute();
    });
    this.bindVideoEndEvent();
  }

  bindVideoEndEvent() {
    if (this.dataVideoType === "local_video" && this.local_video) {
      this.local_video.addEventListener("ended", () => this.onVideoEnded());
    }
  }

  onVideoEnded() {
    this.isPlaying = false;
    this.dataset.videoPlay = this.isPlaying;
  }

  togglePlay() {
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.playVideo();
      this.dataset.videoPlay = true;
    } else {
      this.dataset.videoPlay = false;
      this.pauseVideo();
    }
  }

  toggleMute() {
    this.isMute = !this.isMute;
    if (this.isMute) {
      this.muteVideo();
      this.dataset.videoMute = true;
    } else {
      this.unMuteVideo();
      this.dataset.videoMute = false;
    }
  }

  muteVideo() {
    if (this.dataVideoType === "youtube") {
      this.iframe.contentWindow.postMessage(
        '{"event":"command","func":"mute","args":""}',
        "*"
      );
    } else if (this.dataVideoType === "vimeo") {
      this.iframe.contentWindow.postMessage(
        '{"method":"setVolume","value":0}',
        "*"
      );
    } else if (this.dataVideoType === "local_video" && this.local_video) {
      this.local_video.muted = this.isMute;
    }
  }
  unMuteVideo() {
    if (this.dataVideoType === "youtube") {
      this.iframe.contentWindow.postMessage(
        '{"event":"command","func":"unMute","args":""}',
        "*"
      );
    } else if (this.dataVideoType === "vimeo") {
      this.iframe.contentWindow.postMessage(
        '{"method":"setVolume","value":1}',
        "*"
      );
    } else {
      this.local_video.muted = this.isMute;
    }
  }

  pauseVideo() {
    if (this.dataVideoType === "youtube") {
      this.iframe.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    } else if (this.dataVideoType === "vimeo") {
      this.iframe.contentWindow.postMessage('{"method":"pause"}', "*");
    } else if (this.dataVideoType === "local_video" && this.local_video) {
      this.local_video.pause();
    }
  }

  playVideo() {
    if (this.dataVideoType === "youtube") {
      this.iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        "*"
      );
    } else if (this.dataVideoType === "vimeo") {
      this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
    } else if (this.dataVideoType === "local_video" && this.local_video) {
      this.local_video.play();
    }
  }

  loadVideo() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.iframe) {
              this.iframe.setAttribute(
                "src",
                this.iframe.getAttribute("data-src")
              );
              this.iframe.addEventListener("load", () => {
                if (this.dataVideoType === "youtube") {
                  this.iframe.contentWindow.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*"
                  );
                }
                if (this.dataVideoType === "vimeo") {
                  this.iframe.contentWindow.postMessage(
                    '{"method":"play"}',
                    "*"
                  );
                }
              });
            }
            if (this.dataVideoType === "local_video") {
              this.local_video = this.$("video");
              const video_src = this.local_video
                .querySelector("source")
                .getAttribute("data-src");
              this.local_video.src = video_src;
            }
            observer.disconnect();
          }
        });
      },
      {
        root: null,
        rootMargin: "50px",
        threshold: 0,
      }
    );
    observer.observe(this);
  }

  execute() {
    this.loadVideo();
  }

  static get observedAttributes() {
    return ["data-video-type", "data-video-id"];
  }

  set dataVideoType(newValue) {
    this.setAttribute("data-video-type", newValue);
  }

  get dataVideoType() {
    return this.getAttribute("data-video-type");
  }

  set dataVideoId(newValue) {
    this.setAttribute("data-video-id", newValue);
  }

  get dataVideoId() {
    return this.getAttribute("data-video-id");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.execute();
    }
  }
}
customElements.define("but-load-video", BUTVideoBanner);

document.addEventListener("shopify:section:load", function (event) {
  const stickyHeader = BUTHelper.qs(".header-sticky");
});

// BUTSlideShow (the hand-rolled scroll-snap slideshow) was removed — the
// `slideshow` section now renders <but-swiper>. See snippets/carousel-config.liquid.

class BUTSlideshowLazyLoadingImage extends BUTCustomComponent {
  constructor() {
    super();
    this.image = this.$(".js-image-lazy");
    this.imageMobile = this.$(".js-image-lazy-mobile");
    this.container = this.closest(".js-slideshow-items");
    this.currentItemClass = "js-slideshow-image--current";
    this.slideItem = this.closest(".js-slideshow-item");
    this.sectionId = this.dataset.sectionId;
    this.section = BUTHelper.qs(`#shopify-section-${this.sectionId}`);
  }

  observeImage(primaryImage, secondaryImage) {
    let imageObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          let target = entry.target;
          let parentNode = this.parentNode;

          if (entry.isIntersecting && !this.getAttribute("loaded")) {
            primaryImage && primaryImage.removeAttribute("loading");
            secondaryImage && secondaryImage.removeAttribute("loading");
            this.setAttribute("loaded", true);
            parentNode.classList.add(this.currentItemClass);
          } else if (entry.intersectionRatio == 0) {
            parentNode.classList.remove(this.currentItemClass);
          } else {
            if (this.getAttribute("loaded")) {
              parentNode.classList.add(this.currentItemClass);
            }
          }
        });
      },
      {
        root: this.container,
        rootMargin: `100px -2px 100px -2px`,
        threshold: 0,
      }
    );
    primaryImage && imageObserver.observe(primaryImage);
  }

  loadImage() {
    let resizeObserver = new ResizeObserver((entries) => {
      if (!window.matchMedia("(max-width: 767px)").matches) {
        this.image && this.observeImage(this.image, this.imageMobile);
      } else {
        if (this.imageMobile) {
          this.observeImage(this.imageMobile, this.image);
        } else {
          this.image && this.observeImage(this.image, this.imageMobile);
        }
      }
    });

    resizeObserver.observe(document.body);

    if (!window.matchMedia("(max-width: 767px)").matches) {
      this.image && this.observeImage(this.image, this.imageMobile);
    } else {
      if (this.imageMobile) {
        this.observeImage(this.imageMobile, this.image);
      } else {
        this.image && this.observeImage(this.image, this.imageMobile);
      }
    }
  }

  execute() {
    this.loadImage();
  }

  connectedCallback() {
    this.execute();
  }
}

customElements.define("but-slideshow-load-img", BUTSlideshowLazyLoadingImage);

class BUTVideo extends BUTCustomComponent {
  constructor() {
    super();
    this.mediaContent = this.$(".js-media-trigger");
    this.button = this.$(".js-load-media-trigger");
  }

  execute() {
    this.bindEventHandlers();
  }

  connectedCallback() {
    this.execute();
  }

  bindEventHandlers() {
    this.addEventListener("click", () => {
      this.button.click();
      this.mediaContent.classList.add("d-none-important");
      this.classList.remove("but-mask");
    });
  }
}

customElements.define("but-video", BUTVideo);

class BUTProductSlideShow extends BUTCustomComponent {
  constructor() {
    super();
    this.hide_variant = this.dataset.hideVariantImage;
    this.queryElements();
    this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
    this.scrollTimeout = null;
    this.swiperInstance = null;
    this.swiperSlideChangeHandler = null;
  }

  // A variation switch (variation.js) clones the gallery from the fetched
  // markup, and cloneNode upgrades the clone while it is still detached. Wait
  // for the connection so the swipe listener lands on the new slides, not on
  // the old gallery that is about to be replaced.
  connectedCallback() {
    if (this.initialized) {
      this.refresh();
      return;
    }
    this.initialized = true;
    this.queryElements();
    this.bindEventHandlers();
    this.bindMobileScrollHandler();
    this.bindSwiperHandler();
    this.bindSectionReloadHandler();
  }

  queryElements() {
    // Look inside this gallery first: a page-wide lookup by section id can
    // still return the outgoing gallery while it is being swapped
    this.carousel =
      this.$(`but-carousel[data-section-id="${this.dataset.section}"]`) ||
      BUTHelper.qs(`but-carousel[data-section-id="${this.dataset.section}"]`);
    this.thumb_carousel =
      this.$(`but-slideshow-carousel[data-section="${this.dataset.section}"]`) ||
      BUTHelper.qs(`but-slideshow-carousel[data-section="${this.dataset.section}"]`);
    this.slideshowItems = this.carousel 
      ? this.carousel.querySelector(".js-product-slideshow, .js-carousel-items") 
      : this.$(".js-product-slideshow, .js-carousel-items");
  }

  // The variant change replaces the gallery markup: point at the new carousel
  // and thumbnails, the old ones are no longer in the page
  refresh() {
    this.slideshowItems?.removeEventListener("scroll", this.onMobileScroll);
    this.releasePendingMedia();
    this.queryElements();
    this.bindEventHandlers();
    if (this.dataset.swiper === "true" || !this.slideshowItems) return;
    this.slideshowItems.addEventListener("scroll", this.onMobileScroll, { passive: true });
    if (this.isMobile) this.handleMobileScroll();
  }

  bindSectionReloadHandler() {
    // Rebind Swiper handler when section is reloaded (Swiper manager reinitializes)
    document.addEventListener("shopify:section:load", () => {
      if (this.dataset.swiper === "true") {
        // Small delay to ensure Swiper manager has reinitialized
        setTimeout(() => {
          this.bindSwiperHandler();
        }, 200);
      }
    });
  }

  disconnectedCallback() {
    this.releasePendingMedia();
    // Clean up Swiper event listener
    if (this.swiperInstance && this.swiperSlideChangeHandler) {
      this.swiperInstance.off('slideChange', this.swiperSlideChangeHandler);
      this.swiperSlideChangeHandler = null;
      this.swiperInstance = null;
    }
  }

  bindEventHandlers() {
    this.$$(".js-slideshow-btn-thumb").forEach((e, i) => {
      if (i === 0) {
        e.closest(".js-product-slideshow-thumb").classList.add(
          "is-active-item"
        );
      }
      e.addEventListener("click", this.setActiveMedia.bind(this, e));
    });
  }

  bindSwiperHandler() {
    // Check if Swiper is being used
    if (this.dataset.swiper !== "true") return;
    
    // Clean up existing handler if any
    if (this.swiperInstance && this.swiperSlideChangeHandler) {
      this.swiperInstance.off('slideChange', this.swiperSlideChangeHandler);
      this.swiperSlideChangeHandler = null;
    }
    
    // Get Swiper instance from manager
    const manager = BUTHelper.qs("but-swiper-manager");
    if (!manager || !manager.instances) return;
    
    // Wait for Swiper to be initialized
    let retryCount = 0;
    const maxRetries = 50; // Max 5 seconds (50 * 100ms)
    
    const checkSwiper = () => {
      this.swiperInstance = manager.instances.get(this);
      if (this.swiperInstance) {
        // Bind to Swiper's slideChange event
        this.swiperSlideChangeHandler = () => {
          if (!this.isMobile) return;
          this.handleSwiperSlideChange();
        };
        this.swiperInstance.on('slideChange', this.swiperSlideChangeHandler);
        // Initialize thumbnail on first load
        this.handleSwiperSlideChange();
      } else if (retryCount < maxRetries) {
        // Retry after a short delay if Swiper isn't ready yet
        retryCount++;
        setTimeout(checkSwiper, 100);
      }
    };
    
    // Start checking for Swiper instance
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkSwiper);
    } else {
      checkSwiper();
    }
  }

  handleSwiperSlideChange() {
    if (!this.swiperInstance || !this.isMobile) return;
    
    // Get the active slide from Swiper (real slide, not clone)
    const activeSlide = this.swiperInstance.slides[this.swiperInstance.activeIndex];
    if (!activeSlide) return;
    
    // The slide element might be the product slideshow item itself, or contain it
    let productSlideItem = activeSlide;
    if (!productSlideItem.classList.contains("js-product-slideshow-item")) {
      productSlideItem = activeSlide.querySelector(".js-product-slideshow-item");
    }
    
    if (!productSlideItem) return;
    
    const mediaId = productSlideItem.getAttribute("data-media-id");
    if (mediaId) {
      this.updateThumbnailByMediaId(mediaId);
    }
  }

  bindMobileScrollHandler() {
    this.onMobileScroll = this.handleMobileScroll.bind(this);

    if (!this.slideshowItems) return;

    // Swiper handles its own events, so we use Swiper's slideChange instead
    if (this.dataset.swiper === "true") return;

    this.slideshowItems.addEventListener("scroll", this.onMobileScroll, { passive: true });

    window.addEventListener("resize", () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
      // Initialize active thumbnail when switching to mobile
      if (this.isMobile && !wasMobile) this.handleMobileScroll();
    });

    // Initialize active thumbnail based on first visible slide
    if (this.isMobile) this.handleMobileScroll();
  }

  handleMobileScroll() {
    // One update per frame: the thumbnail follows the swipe instead of
    // waiting for the scroll to stop
    if (this.scrollFrame) return;

    this.scrollFrame = requestAnimationFrame(() => {
      this.scrollFrame = null;
      if (!this.isMobile) return;

      const container = this.slideshowItems;
      if (!container) return;

      const slides = this.$$(".js-product-slideshow-item");
      if (!slides.length) return;

      // Find the slide that is most visible/centered
      const containerRect = container.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;

      let activeSlide = null;
      let minDistance = Infinity;

      slides.forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(containerCenter - slideCenter);

        // Check if slide is at least partially visible
        if (slideRect.right > containerRect.left && slideRect.left < containerRect.right) {
          if (distance < minDistance) {
            minDistance = distance;
            activeSlide = slide;
          }
        }
      });

      if (!activeSlide) return;

      const mediaId = activeSlide.getAttribute("data-media-id");
      if (!mediaId) return;

      // A thumbnail tap scrolls past the slides in between: keep the tapped
      // thumbnail active until the carousel reaches it
      if (this.pendingMediaId) {
        if (this.pendingMediaId !== mediaId) return;
        this.releasePendingMedia();
      }

      const activeThumb = this.$(".js-product-slideshow-thumb.is-active-item");
      if (activeThumb?.getAttribute("data-media-target-id") === mediaId) return;

      this.updateThumbnailByMediaId(mediaId);
    });
  }

  holdPendingMedia(mediaId) {
    this.releasePendingMedia();
    this.pendingMediaId = mediaId;
    this.pendingMediaTimeout = setTimeout(() => {
      this.releasePendingMedia();
      this.handleMobileScroll();
    }, 1000);
  }

  releasePendingMedia() {
    clearTimeout(this.pendingMediaTimeout);
    this.pendingMediaId = null;
  }

  // Show a media item without animation (used when the lightbox moves to another image)
  showMedia(mediaId) {
    const activeMedia = this.$(`.js-product-slideshow-item[data-media-id="${mediaId}"]`);
    if (!activeMedia) return;

    if (window.matchMedia("(max-width: 1024px)").matches) {
      const container = this.slideshowItems;
      if (container) {
        this.holdPendingMedia(mediaId);
        container.scrollTo({
          left:
            container.scrollLeft +
            activeMedia.getBoundingClientRect().left -
            container.getBoundingClientRect().left,
          behavior: "instant",
        });
      }
      this.updateThumbnailByMediaId(mediaId);
    } else if (this.hide_variant == "true") {
      const thumbButton = this.$(`.js-slideshow-btn-thumb[data-target="${mediaId}"]`);
      thumbButton && this.setActiveMedia(thumbButton);
    }
  }

  updateThumbnailByMediaId(mediaId) {
    // Remove active class from all thumbnails
    this.$$(".js-product-slideshow-thumb").forEach((element) => {
      element.classList.remove("is-active-item");
    });
    
    // Find and activate the matching thumbnail
    const thumbnails = this.$$(".js-product-slideshow-thumb");
    thumbnails.forEach((thumb) => {
      const thumbMediaId = thumb.getAttribute("data-media-target-id");
      if (thumbMediaId === mediaId) {
        thumb.classList.add("is-active-item");
        
        // Scroll thumbnail into view
        this.scrollThumbnailIntoView(thumb);
      }
    });
  }

  scrollThumbnailIntoView(thumb) {
    if (!this.thumb_carousel || !this.thumb_carousel.container) return;
    
    const container = this.thumb_carousel.container;
    
    // Check if we're on mobile (horizontal layout) or desktop (vertical layout)
    const isMobile = window.matchMedia("(max-width: 1024px)").matches;
    
    if (isMobile) {
      // Horizontal scrolling for mobile
      const thumbLeft = thumb.offsetLeft;
      const thumbWidth = thumb.offsetWidth;
      const containerWidth = container.clientWidth;
      const scrollLeft = container.scrollLeft;
      
      // Check if thumbnail is not fully visible horizontally
      const isFullyVisible = 
        thumbLeft >= scrollLeft && 
        (thumbLeft + thumbWidth) <= (scrollLeft + containerWidth);
      
      if (!isFullyVisible) {
        // Center the thumbnail in the container
        const targetScroll = thumbLeft - (containerWidth / 2) + (thumbWidth / 2);
        container.scrollTo({
          left: Math.max(0, targetScroll),
          behavior: "smooth"
        });
      }
    } else {
      // Vertical scrolling for desktop
      const thumbTop = thumb.offsetTop;
      const thumbHeight = thumb.offsetHeight;
      const containerHeight = container.clientHeight;
      const scrollTop = container.scrollTop;
      
      // Check if thumbnail is not fully visible vertically
      const isFullyVisible = 
        thumbTop >= scrollTop && 
        (thumbTop + thumbHeight) <= (scrollTop + containerHeight);
      
      if (!isFullyVisible) {
        // Center the thumbnail in the container
        const targetScroll = thumbTop - (containerHeight / 2) + (thumbHeight / 2);
        container.scrollTo({
          top: Math.max(0, targetScroll),
          behavior: "smooth"
        });
      }
    }
  }

  setActiveMedia(e) {
    let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);
    let activeThumb = e.closest("but-slideshow-carousel-itm");
    if (!activeMedia) return;

    if (!window.matchMedia("(max-width: 1024px)").matches) {
      this.$$(".js-product-slideshow-item").forEach((element) => {
        element.classList.remove("d-block");

        this.hide_variant == "true" && element.classList.add("d-none");
      });

      this.$$(".js-product-slideshow-thumb").forEach((element) => {
        element.classList.remove("is-active-item");
      });

      activeMedia.classList.add("d-block");
      this.hide_variant == "true" && activeMedia.classList.remove("d-none");

      activeThumb.classList.add("is-active-item");
      
      // Scroll thumbnail into view on desktop
      this.scrollThumbnailIntoView(activeThumb);

      this.playActiveVideo(activeMedia);
      this.playActiveModel(activeMedia);
    } else {
      this.pauseAllVideo();
      this.$$(".js-product-slideshow-thumb").forEach((element) => {
        element.classList.remove("is-active-item");
      });
      activeThumb.classList.add("is-active-item");
      
      // Scroll thumbnail into view on mobile
      this.scrollThumbnailIntoView(activeThumb);

      this.holdPendingMedia(e.dataset.target);

      activeMedia.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  }

  pauseAllModel() {
    BUTHelper.qsa("but-prd-media-itm-model").forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  pauseAllVideo() {
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='youtube']"
    ).forEach((video) => {
      video.player && video.player?.pauseVideo();
    });
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='vimeo'])"
    ).forEach((video) => {
      if (video.playerVimeo && typeof video.playerVimeo.pause === "function") {
        video.playerVimeo.pause();
      }
    });
    BUTHelper.qsa(".js-media-item-video").forEach((video) => {
      if (typeof video.pause === "function") {
        video.pause();
      }
    });
  }

  playActiveVideo(activeItem) {
    this.pauseAllVideo();
    let deferredExternalVideo = activeItem.querySelector(
      ".js-product-media-deferred-video"
    );

    if (deferredExternalVideo) deferredExternalVideo.loadContent();
  }

  playActiveModel(activeItem) {
    //this.pauseAllModel();
    let deferredExternalModel = activeItem.querySelector(
      ".js-product-media-deferred-model"
    );
    if (deferredExternalModel) deferredExternalModel.loadContent();
  }
}
customElements.define("but-prd-slideshow", BUTProductSlideShow);

class BUTSlideShowCarousel extends BUTCustomComponent {
  constructor() {
    super();

    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");

    // Resolve through the enclosing gallery: on a variation switch this runs on
    // a detached clone, where a page-wide lookup would return the old gallery
    this.slideshow =
      this.closest("but-prd-slideshow") ||
      BUTHelper.qs(`but-prd-slideshow[data-section="${this.dataset.section}"]`);
    this.carousel =
      this.slideshow?.querySelector(
        `but-carousel[data-section-id="${this.dataset.section}"]`
      ) ||
      BUTHelper.qs(`but-carousel[data-section-id="${this.dataset.section}"]`);
    this.carouselLayout = this.getAttribute("data-layout");
    this.window_width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    this.transform();

    window.addEventListener("resize", (e) => {
      let windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (this.window_width != windowWidth) {
        this.transform(e);
        this.window_width = windowWidth;
      }
    });
    // this.init();
    // this.bindEventHandlers();
  }

  transform(e) {
    if (
      !window.matchMedia("(min-width: 1025px)").matches
    ) {
      setTimeout(() => {
        this.horizontalInit();
        this.horizontalBindEventHandlers();
        if (typeof e != "undefined") {
          this.horizontalSetActiveMedia();
        }
      }, 200);
    } else {
      setTimeout(() => {
        this.init();
        this.bindEventHandlers();
        if (typeof e != "undefined") {
          this.setActiveMedia();
        }
      }, 200);
    }
  }
  /* horizontal */
  horizontalInit() {
    this.itemsToShow = Array.from(this.carousels).filter(
      (element) => element.clientWidth > 0
    );

    if (this.itemsToShow.length < 2) {
      this.horizontalTogglePagination(false);
      return;
    }
    this.gutter =
      parseFloat(
        window
          .getComputedStyle(this.itemsToShow[1], null)
          .getPropertyValue("padding-left")
      ) +
      parseFloat(
        window
          .getComputedStyle(this.itemsToShow[1], null)
          .getPropertyValue("padding-right")
      );

    this.itemOffset =
      this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor(
      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) /
        this.itemOffset
    );
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.horizontalUpdateCarousel();
  }
  horizontalUpdateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML =
          this.currentPage +
          `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (
      this.horizontalIsItemVisible(this.itemsToShow[0]) &&
      this.container.scrollLeft === 0
    ) {
      this.prevBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement?.removeAttribute("disabled");
    }
    if (
      this.horizontalIsItemVisible(
        this.itemsToShow[this.itemsToShow.length - 1]
      )
    ) {
      this.nextBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement?.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.horizontalTogglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.horizontalTogglePagination(false);
    }
  }
  horizontalIsItemVisible(element, offset = 0) {
    const lastVisibleItem =
      this.container.clientWidth + this.container.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleItem &&
      element.offsetLeft >= this.container.scrollLeft
    );
  }
  horizontalOnButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 1025px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (
      this.container.scrollLeft == 0 ||
      this.horizontalIsItemVisible(
        this.itemsToShow[this.itemsToShow.length - 1]
      )
    ) {
      gutter = this.gutter;
    }
    this.itemScrollPosition =
      event.currentTarget.name === "next"
        ? this.container.scrollLeft - gutter + step * this.itemOffset
        : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  horizontalBindEventHandlers() {
    if (this.prevBtnElement) {
      this.prevBtnElement.addEventListener(
        "click",
        this.horizontalOnButtonClick.bind(this)
      );
    }
    if (this.nextBtnElement) {
      this.nextBtnElement.addEventListener(
        "click",
        this.horizontalOnButtonClick.bind(this)
      );
    }
    this.container.addEventListener(
      "scroll",
      BUTHelper.debounce(this.horizontalUpdateCarousel.bind(this), 100)
    );
  }
  horizontalTogglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  horizontalSetActiveMedia() {
    let activeThumb = this.$("but-slideshow-carousel-itm.is-active-item");
    // let slideshow = BUTHelper.qs(
    //   `but-prd-slideshow[data-section="${this.dataset.section}"]`
    // );
    // let carousel = BUTHelper.qs(
    //   `but-carousel[data-section-id="${this.dataset.section}"]`
    // );
    if (activeThumb) {
      this.container.scrollTo({
        left: activeThumb.offsetLeft,
        behavior: "auto",
      });

      let activeMedia = this.slideshow.$(
        `but-carousel-itm[data-media-id="${activeThumb.dataset.mediaTargetId}"]`
      );

      this.carousel.querySelector(".js-carousel-items").scrollTo({
        left: activeMedia.offsetLeft,
        behavior: "auto",
      });
    }
  }
  /* horizontal */
  /* Vertical */
  init() {
    this.itemsToShow = Array.from(this.carousels).filter(
      (element) => element.clientWidth > 0
    );
    if (this.itemsToShow.length < 2) {
      this.togglePagination(false);
      return;
    }

    this.gutter =
      parseFloat(
        window
          .getComputedStyle(this.itemsToShow[1], null)
          .getPropertyValue("padding-top")
      ) +
      parseFloat(
        window
          .getComputedStyle(this.itemsToShow[1], null)
          .getPropertyValue("padding-bottom")
      );
    this.itemOffset =
      this.itemsToShow[1].offsetTop - this.itemsToShow[0].offsetTop;
    this.itemsPerPage = Math.floor(
      (this.container.clientHeight - this.itemsToShow[0].offsetTop) /
        this.itemOffset
    );
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;

    this.updateCarousel();
  }
  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.container.scrollTop / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML =
          this.currentPage +
          `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (
      this.isItemVisible(this.itemsToShow[0]) &&
      this.container.scrollTop === 0
    ) {
      this.prevBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement?.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement?.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement?.removeAttribute("disabled");
    }

    if (this.totalPages > 1) {
      this.togglePagination(true);
    }

    if (this.totalPages <= 1) {
      this.togglePagination(false);
    }
  }
  togglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }
  isItemVisible(element, offset = 0) {
    const lastVisibleItem =
      this.container.clientHeight + this.container.scrollTop - offset;
    return (
      element.offsetTop + element.clientHeight - 1 <=
        Math.ceil(lastVisibleItem) &&
      element.offsetTop >= this.container.scrollTop
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 1025px)");

    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (
      this.container.scrollTop == 0 ||
      this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
    ) {
      gutter = this.gutter;
    }
    this.itemScrollPosition =
      event.currentTarget.name === "next"
        ? this.container.scrollTop - gutter + step * this.itemOffset
        : this.container.scrollTop + gutter - step * this.itemOffset;

    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        top: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    this.prevBtnElement.addEventListener(
      "click",
      this.onButtonClick.bind(this)
    );
    this.nextBtnElement.addEventListener(
      "click",
      this.onButtonClick.bind(this)
    );
    this.container.addEventListener(
      "scroll",
      BUTHelper.debounce(this.updateCarousel.bind(this), 100)
    );
  }

  setActiveMedia() {
    let activeThumb = this.$("but-slideshow-carousel-itm.is-active-item");

    if (activeThumb) {
      this.container.scrollTo({
        top: activeThumb.offsetTop,
        behavior: "auto",
      });

      let activeMedia = this.slideshow.$(
        `but-carousel-itm[data-media-id="${activeThumb.dataset.mediaTargetId}"]`
      );

      this.slideshow.$$(".js-product-slideshow-item").forEach((element) => {
        element.classList.remove("d-block");
        this.slideshow.hide_variant == "true" &&
          element.classList.add("d-none");
      });

      activeMedia.classList.add("d-block");
      this.slideshow.hide_variant == "true" &&
        activeMedia.classList.remove("d-none");
    }
  }
}
customElements.define("but-slideshow-carousel", BUTSlideShowCarousel);

class BUTZoomMedia extends BUTCustomComponent {
  constructor() {
    super();
    this.zoomView = this.querySelector(".js-zoom-view");
    this.mediaImage = this.querySelector(".js-media-image");
    this.wrapper = this.querySelector(".js-zoom-wrapper");
    this.galleryIcon = this.querySelector(".js-gallery-icon");
    this.scaleFactor = 1.5;
  }
  connectedCallback() {
    this.init();
  }

  init() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if (
      this.classList.contains("open-zoom") &&
      window.matchMedia("(min-width: 1195px)").matches
    ) {
      this.addEventListener("mouseenter", this.onMouseEnterEvent.bind(this));
      this.addEventListener("mouseleave", this.onMouseLeaveEvent.bind(this));
      this.addEventListener("mousemove", this.onMouseMoveEvent.bind(this));
    }
  }

  onMouseEnterEvent(event) {
    const rect = this.mediaImage.getBoundingClientRect();
    this.wrapper.classList.remove("d-none");
    this.zoomView.style.width = `${rect.width}px`;
    this.zoomView.style.height = `${rect.height}px`;
  }

  onMouseLeaveEvent(event) {
    this.wrapper.classList.add("d-none");
  }

  onMouseMoveEvent(event) {
    const rect = this.mediaImage.getBoundingClientRect();
    const offsetX = event.clientX - rect.left;
    const offsetY = event.clientY - rect.top;
    const percentOffsetX = offsetX / rect.width;
    const percentOffsetY = offsetY / rect.height;
    const imgWidth = rect.width * this.scaleFactor;
    const imgHeight = rect.height * this.scaleFactor;
    const zoomWidth = this.wrapper.offsetWidth;
    const zoomHeight = this.wrapper.offsetHeight;
    const centerContainerX = zoomWidth / 2;
    const centerContainerY = zoomHeight / 2;
    const targetImgX = imgWidth * percentOffsetX;
    const targetImgY = imgHeight * percentOffsetY;
    const translateX = centerContainerX - targetImgX;
    const translateY = centerContainerY - targetImgY;
    const maxTranslateX = zoomWidth - imgWidth;
    const maxTranslateY = zoomHeight - imgHeight;
    const clampedTranslateX = Math.max(Math.min(translateX, 0), maxTranslateX);
    const clampedTranslateY = Math.max(Math.min(translateY, 0), maxTranslateY);

    this.zoomView.style.transform = `translate(${clampedTranslateX}px, ${clampedTranslateY}px) scale(${this.scaleFactor})`;

    let zoomX = event.offsetX + 10;
    let zoomY = event.offsetY + 10;
    if (rect.width - zoomX < this.wrapper.offsetWidth) {
      zoomX = zoomX - this.wrapper.offsetWidth - 20;
      if (zoomX < 0) zoomX = event.offsetX + 10;
    }
    if (rect.height - zoomY < this.wrapper.offsetHeight) {
      zoomY = zoomY - this.wrapper.offsetHeight - 20;
      if (zoomY < 0) zoomY = event.offsetY + 10;
    }
    if (
      this.contains(event.target) &&
      !this.galleryIcon?.contains(event.target)
    ) {
      this.wrapper.classList.remove("d-none");
      this.zoomView.style.width = `${rect.width}px`;
      this.zoomView.style.height = `${rect.height}px`;
    } else {
      this.wrapper.classList.add("d-none");
    }
    this.wrapper.style.left = `${zoomX}px`;
    this.wrapper.style.top = `${zoomY}px`;
  }
}
customElements.define("but-zoom-media", BUTZoomMedia);
class BUTProductSlideShowItem extends BUTCustomComponent {
  constructor() {
    super();
    //this.$ = this.querySelector.bind(this);
    this.openGalleryButton = this.$(".js-product-media-open-gallery-btn");
    if (this.openGalleryButton) {
      this.openGalleryButton.addEventListener("click", (e) => {
        this.openDialogGallery(e);
      });
    }
    this.slideshow = this.closest("but-prd-slideshow");
    this.parent = this.closest("but-carousel-itm");

    this.prepare();
  }

  openDialogGallery(e) {
    let dialog = BUTHelper.qs(`#${e.currentTarget.dataset.galleryDialogId}`);
    if (dialog) {
      dialog.showModal(e.currentTarget, true);
      this.slideshow.pauseAllVideo();
    }
  }

  prepare() {
    if (!window.matchMedia("(max-width: 459px)").matches) {
      if (!this.parent.classList.contains("d-block")) {
        this.slideshow.hide_variant == "true" &&
          this.parent.classList.add("d-none");
      }
    } else {
      this.slideshow.hide_variant == "true" &&
        this.parent.classList.remove("d-none");
    }
    let resizeObserver = new ResizeObserver((entries) => {
      if (!window.matchMedia("(max-width: 459px)").matches) {
        if (!this.parent.classList.contains("d-block")) {
          this.slideshow.hide_variant == "true" &&
            this.parent.classList.add("d-none");
        }
      } else {
        this.slideshow.hide_variant == "true" &&
          this.parent.classList.remove("d-none");
      }
    });
    resizeObserver.observe(document.body);
  }
}
customElements.define("but-prd-slideshow-itm", BUTProductSlideShowItem);

class BUTQuantityInput extends BUTCustomComponent {
  constructor() {
    super();
    this.input = this.$(`.js-quantity-input`);
    this.changeEvent = new Event("change", { bubbles: true });
    this.allBtns = this.$$(".js-quantity-btn");
    this.productQuantity = parseInt(this.dataset.productQuantity);
    this.container = this.closest(".js-quantity-wrapper");
    this.message = this.container?.querySelector(".js-max-quantity-message");
    this.step = parseInt(this.input.step);
    this.currentCartItem = this.closest(".js-product-container")?.querySelector(
      ".js-volume-cart-item"
    );
    this.currentCartItemValue = parseInt(this.currentCartItem?.value);
    this.volumePricing = this.closest(".js-product-container")?.querySelector(
      "quantity-pricing"
    );
    this.quantityMessage = this.container?.querySelector(
      ".js-quantity-pricing-message"
    );
    this.minQuantityMessage = this.container?.querySelector(
      ".js-min-quantity-pricing-message"
    );
    this.maxQuantityMessage = this.container?.querySelector(
      ".js-max-quantity-pricing-message"
    );
    this.stepQuantityMessage = this.container?.querySelector(
      ".js-step-quantity-pricing-message"
    );
  }

  connectedCallback() {
    this.bindEventHandlers();
  }

  bindEventHandlers() {
    if (this.closest(".js-cart-item")) {
      this.currentCartItemValue = 0;
      this.volumePricing =
        this.closest(".js-cart-item")?.querySelector("quantity-pricing");
    }
    this.allBtns.forEach((button) =>
      button.addEventListener("click", this.onButtonClickHandler.bind(this))
    );
    this.input.addEventListener("input", this.handleInputChange.bind(this));
    this.input.addEventListener("change", this.updatePriceItem.bind(this));
    this.updatePriceItem();
  }

  handleInputChange(event) {
    event.preventDefault();
    let value = parseInt(this.input.value) || 0;
    if (value <= this.productQuantity || Number.isNaN(value) || value == 0) {
      this.showMessage(true);
    } else {
      this.showMessage(false);
    }
  }

  onButtonClickHandler(event) {
    event.preventDefault();
    let previousValue = parseInt(this.input.value);
    let value;
    if (event.currentTarget.dataset.name === "plus") {
      value = parseInt(this.input.value) + this.step;
    } else {
      value = parseInt(this.input.value) - this.step;
    }
    if (value <= parseInt(this.productQuantity)) {
      event.currentTarget.dataset.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
      this.showMessage(true);
      this.toggleAnimation("animated");
    } else {
      this.showMessage(false);
      this.toggleAnimation("error-animated");
    }
    if (previousValue !== parseInt(this.input.value)) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  toggleAnimation(animationClass) {
    const oppositeClass =
      animationClass === "animated" ? "error-animated" : "animated";
    this.input.classList.remove(oppositeClass);
    if (this.input.classList.contains(animationClass))
      this.input.classList.remove(animationClass);
    void this.input.offsetWidth; // Trigger reflow
    this.input.classList.add(animationClass);
  }

  validateQuantity(value) {
    const minValue = parseInt(this.input.min);
    const maxValue = parseInt(this.input.max);
    const stepValue = parseInt(this.input.step);

    const toggleMessage = (message, show) => {
      message?.classList.toggle("d-none-important", !show);
    };

    const showMessages = (show, min, max, step) => {
      toggleMessage(this.quantityMessage, show);
      toggleMessage(this.minQuantityMessage, min);
      toggleMessage(this.maxQuantityMessage, max);
      toggleMessage(this.stepQuantityMessage, step);
    };

    if (value < minValue) {
      showMessages(true, true, false, false);
    } else if (value > maxValue) {
      showMessages(true, false, true, false);
    } else if (value % stepValue !== 0) {
      showMessages(true, false, false, true);
    } else {
      showMessages(false, false, false, false);
    }
  }

  updatePriceItem() {
    if (this.input) this.inputValue = parseInt(this.input.value);
    let minPricingMoney = null;
    this.currentValue = this.currentCartItemValue + this.inputValue;
    this.volumePricing?.querySelectorAll("li").forEach((item) => {
      const quantity = parseInt(
        item.querySelector(".js-pricing-item-quantity").textContent
      );
      const priceText = item.querySelector(
        ".js-pricing-item-price"
      )?.textContent;
      if (this.currentValue >= quantity) {
        minPricingMoney = priceText;
      }
    });
    let priceDisplay;
    if (this.closest(".js-product-container")) {
      priceDisplay = this.closest(".js-product-container")?.querySelector(
        ".price-item"
      );
    } else {
      priceDisplay =
        this.closest(".js-cart-item")?.querySelector(".price-item");
    }
    if (
      minPricingMoney !== null &&
      priceDisplay &&
      priceDisplay.textContent !== minPricingMoney
    ) {
      priceDisplay.textContent = minPricingMoney;
    }
  }

  showMessage(show) {
    if (!this.message) return;
    if (show) {
      if (!this.message.classList.contains("d-none-important"))
        this.message.classList.add("d-none-important");
      if (this.input.value > 0) this.validateQuantity(this.input.value);
    } else {
      const messages = [
        this.quantityMessage,
        this.minQuantityMessage,
        this.maxQuantityMessage,
        this.stepQuantityMessage,
      ];

      messages.forEach((message) => {
        if (message && !message.classList.contains("d-none-important")) {
          message.classList.add("d-none-important");
        }
      });
      this.message.classList.remove("d-none-important");
    }
  }
}
customElements.define("but-qty-inp", BUTQuantityInput);

class BUTProductRecommendations extends BUTCustomComponent {
  connectedCallback() {
    if (this.hasRequested) return;
    this.hasRequested = true;

    // Turns on the shimmer placeholder in snippets/carousel-skeleton.liquid.
    // It is set here rather than in the markup so a section whose JS never runs
    // shows nothing instead of a placeholder that shimmers forever.
    this.dataset.loadingState = "loading";

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("but-prd-recom");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.executeScriptElements(this);
            // Swaps the skeleton out for the staggered card reveal. Set after
            // the injection so the cards animate from their first painted frame.
            this.dataset.loadingState = "loaded";
          } else {
            this.stopLoading();
          }
        })
        .catch((e) => {
          console.error(e);
          this.stopLoading();
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  // Nothing to show: drop the placeholder rather than leave it shimmering.
  stopLoading() {
    this.removeAttribute("data-loading-state");
  }

  executeScriptElements(containerElement) {
    const scriptElements = containerElement.querySelectorAll("script");

    Array.from(scriptElements).forEach((scriptElement) => {
      const clonedElement = document.createElement("script");

      Array.from(scriptElement.attributes).forEach((attribute) => {
        clonedElement.setAttribute(attribute.name, attribute.value);
      });

      clonedElement.appendChild(
        document.createTextNode(scriptElement.innerHTML)
      );

      scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
    });
  }
}
customElements.define("but-prd-recom", BUTProductRecommendations);

class BUTVariantSelector extends BUTCustomComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.container = this.closest(".js-product-container");
    this.price_selector = ".js-product-price";
    this.inventory_tracking_selector = ".js-inventory-tracking";
    this.variant_picker_selector = ".js-variant-picker";
    this.quantity_container_selector = ".js-product-quantity-container";
    this.quantity_input_selector = ".js-product-quantity";
    this.slideshow_selector = `but-prd-slideshow[data-section="${this.dataset.section}"]`;
    this.sku_selector = ".js-product-sku";
    this.selected_variants = null;
    this.selected_variants_option = null;
    this.variant_data = null;
    this.quickView = this.closest(".js-quick-view-block");
    this.elms = {
      radio_elms: this.$$(".js-variant-radio-item"),
      radio_container_elms: this.$$(".js-variant-radio-container"),
      form: this.container.querySelector(".js-product-form"),
      price: this.container.querySelector(this.price_selector),
      installment_form: BUTHelper.qs(
        `#productFormInstallment-${this.dataset.section}`
      ),
      product_form: this.container.querySelector(".js-but-product-form"),
      inventory_tracking: this.container.querySelector(
        this.inventory_tracking_selector
      ),
      variant_picker: this.container.querySelector(
        this.variant_picker_selector
      ),
      quantity_container: this.container.querySelector(
        this.quantity_container_selector
      ),
      quantity_input: this.container.querySelector(
        this.quantity_input_selector
      ),
      slideshow: BUTHelper.qs(
        `but-prd-slideshow[data-section="${this.dataset.section}"]`
      ),
      thumb_carousel: BUTHelper.qs(
        `but-slideshow-carousel[data-section="${this.dataset.section}"]`
      ),
      carousel: BUTHelper.qs(
        `but-carousel[data-section-id="${this.dataset.section}"]`
      ),
      variant_options: this.$$(".js-variant-option-value"),
      sku: this.container.querySelector(this.sku_selector),
    };

    this.setSelectedVariants();
    this.setCurrentVariant();
    this.updateSelectedVariants();
    this.bindEventHandlers();
    this.setUnavailableOptions();
    this.syncSwatchSelectedState();
  }

  bindEventHandlers() {
    this.addEventListener("change", this.onVariantChangeHandle.bind(this));
  }

  // Mirror each radio's :checked state onto an explicit class on its label.
  // iOS Safari does not reliably repaint `input:checked + label` sibling styles
  // when the checked state moves via a <label> tap (the radio is
  // position:absolute through .visually-hidden), so the previously selected
  // swatch keeps its highlight. Toggling a class on the element itself forces
  // the style recalculation.
  syncSwatchSelectedState() {
    const inputs = [...this.querySelectorAll(".input--variant")];
    // Skip the transient state where a handler has cleared every radio before
    // re-checking the new one (swatch-with-select), so we don't drop the ring.
    if (inputs.length && !inputs.some((input) => input.checked)) return;
    inputs.forEach((input) => {
      input.nextElementSibling?.classList.toggle("is-selected", input.checked);
    });
  }

  onVariantChangeHandle() {
    this.setSelectedVariants();
    this.syncSwatchSelectedState();
    this.setCurrentVariant();
    this.toggleAddButton(true, "", false, false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (this.select_type == "dropdown") {
      this.updateVariantStatuses();
    }
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true, false);
      this.setUnavailable();
      if (this.select_type == "dropdown") {
        this.renderVariantSelectOption();
      } else {
        this.updateSelectedVariants();
      }
      this.setUnavailableOptions(false);
    } else {
      let quickBuyBlock = this.closest(".js-quick-buy-block");
      let bundleProduct = this.closest(".js-bundle-product");
      if (!quickBuyBlock && !this.quickView && !bundleProduct) {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.setActiveMedia();
      this.setUnavailableOptions();
    }
  }

  updateVariantStatuses() {
    const selectedValue = this.querySelector(":checked")?.value;
    const selected_option_one_variants = this.variant_data.filter(
      (variant) => selectedValue === variant.option1
    );
    const input_wrappers = [...this.querySelectorAll(".js-selectbox-wrapper")];

    input_wrappers.forEach((option, index) => {
      if (index === 0) return;

      const option_inputs = [...option.querySelectorAll("option")];
      const previous_option_selected =
        input_wrappers[index - 1].querySelector(":checked").value;
      const available_option_inputs_value = selected_option_one_variants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previous_option_selected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      const radioInputs = [...option.querySelectorAll(`input[type="radio"]`)];

      this.setSelectOptionAvailability(
        option_inputs,
        available_option_inputs_value
      );
      if (radioInputs.length > 0) {
        this.setColorSwatchSelectOptionAvailability(
          radioInputs,
          available_option_inputs_value
        );
      }
    });
  }

  renderVariantSelectOption() {
    this.selected_variants_option = this.selected_variants_option.join(",");
    let variantURL = `${this.dataset.url}?option_values=${this.selected_variants_option}&section_id=${this.dataset.section}`;
    fetch(variantURL)
      .then((response) => response.text())
      .then((responseText) => {
        let markup = new DOMParser().parseFromString(responseText, "text/html");
        const selectSource = markup.querySelectorAll(
          "but-select .js-variant-select-item"
        );
        const selectDestination = this.querySelectorAll(
          "but-select .js-variant-select-item"
        );
        selectSource.forEach((itemSource, indexSource) => {
          selectDestination.forEach((itemDestination, indexDestination) => {
            if (itemDestination && indexSource === indexDestination) {
              itemDestination.innerHTML = itemSource?.innerHTML;
            }
          });
        });
        this.updateSelectedVariants();
      });
  }

  setSelectOptionAvailability(option_inputs, available_option_inputs_value) {
    option_inputs.forEach((input) => {
      if (available_option_inputs_value.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      }
    });
  }

  setColorSwatchSelectOptionAvailability(
    listOfOptions,
    listOfAvailableOptions
  ) {
    listOfOptions.forEach((input) => {
      let parent = this.querySelector(
        `div.js-variant-option-value[data-value="${input
          .getAttribute("data-variant-value")
          .replace(/"/g, '\\"')}"]`
      );
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        parent && parent.classList.remove("product-option--unavailable");
      } else {
        parent && parent.classList.add("product-option--unavailable");
      }
    });
  }

  updateOptionState(available) {
    this.$$(".product-option--sold-out").forEach((e) => {
      e.classList.remove("product-option--sold-out");
    });
    if (!available) {
      this.selected_variants.forEach((e) => {
        let selected = this.$(
          `.js-variant-item[data-variant-value="${e.replace(/"/g, '\\"')}"]`
        );
        if (selected) {
          selected
            .closest(".js-variant-option-value")
            ?.classList.add("product-option--sold-out");
        }
      });
    }
  }

  updateSelectedVariants() {
    this.selected_variants.forEach((variant, index) => {
      const variantValue = `${variant}-${index}`.replace(/"/g, '\\"');
      const selectedElement = this.$(
        `.js-variant-item[data-variant-value="${variantValue}"]`
      );
      if (selectedElement) {
        const variantName =
          selectedElement.getAttribute("data-variant-name") ||
          selectedElement.getAttribute("name");
        const variantValue = selectedElement.dataset.optionVariantValue;
        if (variantName) {
          const targetElement = this.$(
            `.js-variant-radio-option-name[data-option-name="${variantName.replace(
              /"/g,
              '\\"'
            )}"]`
          );
          if (targetElement) {
            targetElement.innerHTML = variant;
          }
          const targetSelectElement = this.$(
            `.js-variant-select-option-name[data-option-name="${variantName.replace(
              /"/g,
              '\\"'
            )}"]`
          );
          if (targetSelectElement) {
            if (variantValue) {
              targetSelectElement.innerHTML = variantValue;
            } else {
              targetSelectElement.innerHTML = variant;
            }
          }
        }
      }
    });
  }

  removeErrorMessage() {
    if (this.elms.product_form) {
      this.elms.product_form.handleErrorMessage();
    }
  }

  updatePickupAvailability() {
    let dataSectionID = this.getAttribute("data-section");
    const pickUpAvailabilityElements = BUTHelper.qsa(
      "but-pickup-avail[data-section]"
    );

    pickUpAvailabilityElements.forEach((pickUpAvailability) => {
      const sectionId = pickUpAvailability.dataset.section;
      if (sectionId !== dataSectionID) return;

      if (this.currentVariant) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.classList.remove("d-block");
        pickUpAvailability.classList.add("d-none");
        pickUpAvailability.innerHTML = "";
      }
    });
  }

  renderProductInfo() {
    let variantURL = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    // Only the latest selection may render: a slower response for an earlier
    // variant would otherwise overwrite the gallery, price and stock
    const requestId = (this.renderRequestId = (this.renderRequestId || 0) + 1);
    fetch(variantURL)
      .then((response) => response.text())
      .then((responseText) => {
        if (requestId !== this.renderRequestId) return;
        let markup = new DOMParser().parseFromString(responseText, "text/html");

        //Update Inventory Tracking
        let inventoryTrackingDestination = this.elms.inventory_tracking;
        let inventoryTrackingSource = markup.querySelector(
          this.inventory_tracking_selector
        );

        if (inventoryTrackingDestination) {
          inventoryTrackingDestination.innerHTML = "";
          if (inventoryTrackingSource) {
            inventoryTrackingDestination.innerHTML =
              inventoryTrackingSource.innerHTML;
          }
        }

        //Update Price
        let priceDestination = this.elms.price;
        let priceSource = markup.querySelector(this.price_selector);

        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
        }
        if (this.elms.price) {
          this.elms.price.classList.remove("d-none-important");
        }

        //Update Discount Code Price
        this.container
          .querySelectorAll(".js-product-discount-price")
          .forEach((discountPriceDestination) => {
            let discountPriceSource = markup.querySelector(
              `.js-product-discount-price[data-block-id="${discountPriceDestination.dataset.blockId}"]`
            );
            if (discountPriceSource) {
              discountPriceDestination.innerHTML = discountPriceSource.innerHTML;
            }
          });

        //Update SKU
        let skuDestination = this.elms.sku;
        let skuSource = markup.querySelector(this.sku_selector);

        if (skuDestination) {
          skuDestination.innerHTML = skuSource?.innerHTML || "";
        }

        //Update Quantity Input
        let quantityContainerDestination =
          this.elms.quantity_container.querySelector(
            ".js-max-quantity-message"
          );
        let quantityContainerSource = markup.querySelector(
          this.quantity_container_selector
        );
        quantityContainerSource = quantityContainerSource?.querySelector(
          ".js-max-quantity-message"
        );
        let quantityInputDestination = this.elms.quantity_input;
        let quantityInputSource = markup.querySelector(
          this.quantity_input_selector
        );
        if (quantityContainerDestination) {
          quantityContainerDestination.classList.add("d-none-important");
          quantityContainerDestination.innerHTML =
            quantityContainerSource?.innerHTML || "";
        }
        if (quantityInputDestination) {
          quantityInputDestination.innerHTML =
            quantityInputSource?.innerHTML || "";
        }
        const selectSource = markup.querySelectorAll(
          "but-select .js-variant-select-item"
        );
        const selectDestination = this.querySelectorAll(
          "but-select .js-variant-select-item"
        );
        selectSource.forEach((itemSource, indexSource) => {
          selectDestination.forEach((itemDestination, indexDestination) => {
            if (itemDestination && indexSource === indexDestination) {
              itemDestination.innerHTML = itemSource?.innerHTML;
            }
          });
        });
        this.updateSelectedVariants();

        //Update SlideShow
        if (this.elms.slideshow?.hide_variant == "false") {
          let slideshowDestination = this.elms.slideshow;
          let slideshowSource = markup.querySelector(this.slideshow_selector);
          if (slideshowDestination && slideshowSource) {
            slideshowDestination.innerHTML = slideshowSource.innerHTML;
          }
          this.elms.thumb_carousel = BUTHelper.qs(
            `but-slideshow-carousel[data-section="${this.dataset.section}"]`
          );
          this.elms.carousel = BUTHelper.qs(
            `but-carousel[data-section-id="${this.dataset.section}"]`
          );
          this.elms.slideshow.refresh();
        }

        let preOrderStatus = this.container.querySelector(
          ".js-product-form-submit-btn"
        )?.dataset.preOrder;
        const preOrderStatusSource = markup.querySelector(
          ".js-product-form-submit-btn"
        )?.dataset.preOrder;
        if (preOrderStatusSource) {
          preOrderStatus = preOrderStatusSource;
        }

        this.toggleAddButton(
          !this.currentVariant.available,
          BUTLanguage.product.PRODUCT_SOLD_OUT,
          true,
          preOrderStatus
        );
      });
  }

  updateVariantInput() {
    const productForms = [this.elms.form, this.elms.installment_form];
    const stockStatus = BUTHelper.qs(".js-inventory-tracking");
    if (stockStatus) stockStatus.classList.remove("d-none");
    productForms.forEach((productForm) => {
      if (productForm) {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `?variant=${this.currentVariant.id}`);
  }

  setActiveMedia() {
    if (this.currentVariant.featured_media) {
      let mediaId = this.currentVariant.featured_media.id;

      let activeMedia = this.elms.slideshow?.querySelector(
        `but-carousel-itm[data-media-id="${this.dataset.section}-${mediaId}"]`
      );

      let activeThumb = this.elms.slideshow?.querySelector(
        `but-slideshow-carousel-itm[data-media-target-id="${this.dataset.section}-${mediaId}"]`
      );

      if (!window.matchMedia("(max-width: 1024px)").matches) {
        this.elms.slideshow
          ?.querySelectorAll(".js-product-slideshow-item")
          .forEach((element) => {
            element.classList.remove("d-block");
            this.elms.slideshow.hide_variant == "true" &&
              element.classList.add("d-none");
          });

        this.elms.slideshow
          ?.querySelectorAll(".js-product-slideshow-thumb")
          .forEach((element) => {
            element.classList.remove("is-active-item");
          });

        activeMedia?.classList.add("d-block");

        if (this.elms.slideshow?.hide_variant == "true") {
          activeMedia?.classList.remove("d-none");
        }

        if (
          activeMedia &&
          this.elms.thumb_carousel?.getAttribute("data-layout") == "carousel"
        ) {
          this.elms.carousel.querySelector(".js-carousel-items").scrollTo({
            left: activeMedia.offsetLeft,
            behavior: "smooth",
          });
        }

        if (activeThumb) {
          this.elms.slideshow
            ?.querySelectorAll("but-slideshow-carousel-itm")
            .forEach((activeThumb) => {
              activeThumb.classList.remove("is-active-item");
            });

          activeThumb.classList.add("is-active-item");
          if (
            this.elms.thumb_carousel?.getAttribute("data-layout") ==
            "carousel-vertical"
          ) {
            this.elms.thumb_carousel
              .querySelector(".js-carousel-items")
              .scrollTo({
                top: activeThumb.offsetTop,
                behavior: "auto",
              });
          } else {
            this.elms.thumb_carousel
              ?.querySelector(".js-carousel-items")
              .scrollTo({
                left: activeThumb.offsetLeft,
                behavior: "auto",
              });
          }
        }
      } else {
        activeMedia &&
          this.elms.carousel?.querySelector(".js-carousel-items").scrollTo({
            left: activeMedia.offsetLeft,
            behavior: "smooth",
          });

        if (activeThumb) {
          this.elms.slideshow
            ?.querySelectorAll("but-slideshow-carousel-itm")
            .forEach((activeThumb) => {
              activeThumb.classList.remove("is-active-item");
            });

          activeThumb.classList.add("is-active-item");
          this.elms.thumb_carousel
            ?.querySelector(".js-carousel-items")
            .scrollTo({
              left: activeThumb.offsetLeft,
              behavior: "auto",
            });
        }
      }

      this.elms.slideshow?.pauseAllVideo();
    }
  }

  pauseAllVideo() {
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='youtube']"
    ).forEach((video) => {
      video.player?.pauseVideo();
    });
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='vimeo'])"
    ).forEach((video) => {
      video.playerVimeo?.pause();
    });
    BUTHelper.qsa(".js-media-item-video").forEach((video) => {
      video.pause();
    });
  }

  setUnavailable() {
    let form = this.elms.form;
    if (!form) return;
    let addBtn = form.querySelector(".js-product-form-submit-btn");
    if (!addBtn) return;
    let addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");
    const stockStatus = BUTHelper.qs(".js-inventory-tracking");
    if (stockStatus) stockStatus.classList.add("d-none");
    if (addBtnText)
      addBtnText.textContent = BUTLanguage.product.PRODUCT_UNAVAILABLE;
    if (this.elms.price) this.elms.price.classList.add("d-none-important");
  }

  getVariantData() {
    this.variant_data =
      this.variant_data ||
      JSON.parse(this.$('[type="application/json"]').textContent);

    this.variant_data.map((e) => {
      e.my_options = [];
      e.options.forEach((elm, index) => {
        e.my_options.push(`${elm}-${index}`);
      });
    });

    return this.variant_data;
  }

  setCurrentVariant() {
    this.currentVariant = this.getVariantData().find((variant) =>
      variant.options.every(
        (option, index) => this.selected_variants[index] === option
      )
    );
  }

  toggleAddButton(
    disable = true,
    text,
    modifyClass = true,
    preOrderStatus = false
  ) {
    let form = this.elms.form;

    if (!form) return;
    let addBtn = form.querySelector(".js-product-form-submit-btn");
    let addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");

    if (!addBtn) return;

    if (disable) {
      addBtn.setAttribute("disabled", "disabled");
      if (text) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      if (preOrderStatus == "true") {
        addBtnText.textContent = BUTLanguage.product.PRODUCT_PRE_ORDER;
      } else {
        addBtnText.textContent = BUTLanguage.product.PRODUCT_ADD_TO_CART;
      }
    }

    if (!modifyClass) return;
  }

  toggleUnavailableOptions(unavailable = false) {
    this.elms.variant_options.forEach((element) => {
      element.classList.toggle("product-option--unavailable", unavailable);
    });
  }

  setUnavailableOptions(checkAvailable = true) {
    if (this.select_type === "dropdown") return;

    this.toggleUnavailableOptions(false);
    this.variant_data = this.variant_data || this.getVariantData();
    const selectedId = this.elms.form?.querySelector('input[name="id"]')?.value;
    this.selected_variant_id = Number(selectedId);
    this.current_variant = this.variant_data.find(
      (v) => v.id === this.selected_variant_id
    );
    let available, currentOptions;
    if (!checkAvailable) {
      available = false;
      currentOptions = this.selected_variants_option;
    } else {
      available = this.current_variant.available;
      currentOptions = this.current_variant.my_options;
    }

    const maxOptions = currentOptions?.length || 0;

    // Collect potentially available variants
    let matchVariants = this.collectMatchVariants(
      maxOptions,
      currentOptions,
      available
    );

    // Extract valid options from matched variants
    const validOptions = this.processValidOptions(
      matchVariants,
      currentOptions,
      available
    );

    // Update UI
    this.updateOptionAvailability(validOptions);
  }

  collectMatchVariants(maxOptions, currentOptions, isCurrentAvailable) {
    let variants = [];

    if (maxOptions > 2) {
      for (let i = 0; i < maxOptions; i++) {
        for (let j = i + 1; j < maxOptions; j++) {
          variants.push(
            ...this.variant_data.filter(
              (v) =>
                v.my_options[i] === currentOptions[i] &&
                v.my_options[j] === currentOptions[j] &&
                v.available
            )
          );
        }
      }
    } else if (maxOptions > 1) {
      for (let i = 0; i < maxOptions; i++) {
        variants.push(
          ...this.variant_data.filter(
            (v) => v.my_options[i] === currentOptions[i] && v.available
          )
        );
      }
    } else {
      variants = this.variant_data.filter((v) => v.available);
    }

    // Include current variant if unavailable to process its options
    if (!isCurrentAvailable) variants.push(this.current_variant);
    return variants;
  }

  processValidOptions(variants, currentOptions, isCurrentAvailable) {
    const validOptions = new Set();

    variants.forEach((variant) => {
      variant.my_options?.forEach((option) => validOptions.add(option));
    });

    // Remove current variant's options if unavailable
    if (!isCurrentAvailable) {
      currentOptions?.forEach((option) => validOptions.delete(option));
    }

    return validOptions;
  }

  updateOptionAvailability(validOptions) {
    this.toggleUnavailableOptions(true);

    validOptions.forEach((value) => {
      const escapedValue = value.replace(/"/g, '\\"');
      const optionEl = this.$(`[data-value="${escapedValue}"]`);
      if (optionEl) optionEl.classList.remove("product-option--unavailable");
    });
  }
}

class BUTVariantRadios extends BUTVariantSelector {
  constructor() {
    super();
    this.select_type = "button";
  }

  setSelectedVariants() {
    let selectors = Array.from(this.$$(".js-variant-radio-container"));
    this.selected_variants = selectors.map((selector) => {
      return Array.from(
        selector?.querySelectorAll(".js-variant-radio-item")
      ).find((radio) => radio.checked).value;
    });

    this.selected_variants_option = selectors.map((selector) => {
      return Array.from(
        selector?.querySelectorAll(".js-variant-radio-item")
      ).find((radio) => radio.checked).dataset.variantValue;
    });
  }
}

customElements.define("but-variant-radios", BUTVariantRadios);

class BUTVariantSelects extends BUTVariantSelector {
  constructor() {
    super();
    this.select_type = "dropdown";
  }

  setSelectedVariants() {
    this.selected_variants = Array.from(
      this.$$(".js-variant-select-item"),
      (select) => select.value
    );
    this.selected_variants_option = Array.from(
      this.$$(".js-variant-select-item"),
      (select) => {
        const selectOption =
          select.querySelectorAll(".js-variant-item")[select.selectedIndex];
        return selectOption?.dataset.variantOption || "";
      }
    );
  }
}
customElements.define("but-variant-selects", BUTVariantSelects);

class BUTVariantSwatchSelect extends BUTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.radios = this.$$(".js-variant-radio-item");
    this.select_id = this.dataset.selectId;
    this.select_element = document.querySelector(`#${this.select_id}`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.radios.forEach((radio) => {
      radio.addEventListener("click", (e) => {
        e.preventDefault();
        Array.from(this.radios, (input) => {
          input.checked = false;
        });

        setTimeout(() => {
          e.target.checked = true;
        });
        if (this.select_element) {
          let option = this.select_element.querySelector(
            `option[value="${e.target.dataset.optionValue.replace(
              /"/g,
              '\\"'
            )}"]`
          );
          option.selected = true;
          this.select_element.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        }
      });
    });
  }
  connectedCallback() {
    this.init();
  }
}
customElements.define("but-variant-swatch-select", BUTVariantSwatchSelect);

class BUTProductForm extends BUTCustomComponent {
  constructor() {
    super();
  }

  init() {
    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-product-form-error-wrapper"),
      error_message: this.$(".js-product-form-error-message"),
      spinner: this.$(".js-product-form-spinner"),
      quantity_input_container: this.closest(
        ".js-product-container"
      )?.querySelector(".js-product-quantity"),
      sticky_header: BUTHelper.qs("but-sticky-header"),
      header: BUTHelper.qs("but-header"),
      announcement_bar: BUTHelper.qs("but-ann-bar"),
      header_cart_status: BUTHelper.qs("#headerCartStatus"),
    };
    this.cartNotiType = document.body.getAttribute("data-cart-noti-type");
    this.cartType = document.body.getAttribute("data-cart-type");
    this.cartNotification = BUTHelper.qs("but-cart-noti");
    this.quickViewDialog = BUTHelper.qs("but-dialog-quickview");
    this.quickBuyDialog = BUTHelper.qs("but-dialog-quick-buy");
    this.quickAddForm = this.getAttribute("data-quick-add-form") === "true";

    this.cartDrawer = BUTHelper.qs("but-cart-drwr");
    this.cartDrawerForm = BUTHelper.qs("but-cart-drwr-frm");
    this.mainCartForm = BUTHelper.qs("but-cart-frm");
    this.cardRecipientForm = BUTHelper.qs("but-gift-card-recipient-form");
    this.interactionPopup = BUTHelper.qs("but-interaction-popup");
    this.giftCardForm = BUTHelper.qs(".js-gift-card-recipient-fields");
    if (this.elms.form) {
      this.elms.form.querySelector("[name=id]").disabled = false;
      this.bindEventHandlers();
    }
  }

  connectedCallback() {
    this.init();
  }

  bindEventHandlers() {
    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(e) {
    e.preventDefault();

    if (this.elms.submit_btn.classList.contains("loading")) return;

    if (!this.quickAddForm) {
      this.hideErrorMessage();
    }

    this.toggleSubmitButtons(false);

    this.elms.spinner?.classList.remove("hidden");
    if (this.elms.header_cart_status) {
      this.elms.header_cart_status.classList.remove(
        "header-cart-status--animate"
      );
    }

    let sections = [];
    if (this.cartNotification) {
      sections = this.cartNotification.getSectionsToRender();
    }
    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender()];
    }
    if (this.mainCartForm) {
      sections = [...sections, ...this.mainCartForm.getSectionsToRender(false)];
    }

    let formData = new FormData(this.elms.form);
    let elementToFocus = this.elms.submit_btn;
    const customizationCodeType = this.closest(
      ".js-product-container"
    )?.querySelectorAll(".js-customization-note-type");
    if (customizationCodeType) {
      customizationCodeType.forEach((item) => {
        const inputElement = item.querySelector(".js-customization-note-input");
        const label = item.querySelector(
          ".js-customization-note-label"
        ).textContent;
        const value =
          item.dataset.customizationCodeType === "text"
            ? inputElement.value
            : inputElement.checked
            ? inputElement.dataset.selectedValue
            : null;
        if (value) formData.append(`properties[${label}]`, value);
      });
    }
    if (sections.length) {
      formData.append(
        "sections",
        sections.map((section) => section.section || section.id)
      );
    }

    formData.append("sections_url", window.location.pathname);
    BUTHelper.fetchConfigHTTP.body = formData;

    fetch(`${routes.cart_add_url}`, BUTHelper.fetchConfigHTTP)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleQuickAddErrorMessage(e.target, true);
          this.handleErrorMessage(response.description, response?.message);
          return;
        }

        if (!response.id) {
          response.id = formData.get("id");
        }

        if (this.elms.sticky_header) {
          if (this.elms.sticky_header.dataset.isEnabled) {
            this.elms.sticky_header.reveal();
          }
        }

        this.handleCartNotification(response, elementToFocus);

        // switch (this.cartNotiType) {
        //   case "popover_notification":
        //     this.handlePopoverNotification(response, elementToFocus);
        //     break;
        //   case "cart_noti":

        //     break;
        //   case "do_nothing":
        //     this.handleDoNothingNotification(response, elementToFocus);
        //     break;
        // }

        // Dispatch cart:update event to trigger cart drawer and header cart icon update
        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: {
            source: 'product-form',
            productVariantId: parseInt(formData.get("id")),
            cartData: response
          }
        }));

        const cartDrawer = BUTHelper.qs("but-cart-drwr");
        if (cartDrawer) {
          cartDrawer.openDrawer(elementToFocus);
          cartDrawer.updateSwiperOpened();
        }

        if (this.interactionPopup)
          this.interactionPopup.handleShowPopupAddToCart();

        if (
          this.elms.quantity_input_container &&
          this.elms.quantity_input_container.dataset.show == "add-to-cart"
        ) {
          this.elms.quantity_input_container.classList.remove("d-none");
          this.elms.quantity_input_container.querySelector("input").value = 1;
        }

        if (this.cardRecipientForm) {
          this.cardRecipientForm.resetRecipientForm();
          this.giftCardForm.classList.add("d-none");
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.toggleSubmitButtons(true);
        this.elms.spinner?.classList.add("hidden");
      });
  }

  handleQuickAddErrorMessage(opener, showError) {
    const cardContainer = opener.closest(".js-product-card-block");
    const errorMessage = cardContainer?.querySelector(
      ".js-quick-buy-error-message"
    );
    if (showError) {
      errorMessage?.classList.remove("d-none-important");
    } else {
      if (!errorMessage?.classList.contains("d-none-important"))
        errorMessage?.classList.add("d-none-important");
    }
  }

  toggleSubmitButtons(enable = true) {
    const action = enable ? "remove" : "add";
    const ariaDisabled = enable ? false : true;

    this.elms.submit_btn.classList[action]("loading");
    this.elms.submit_btn.setAttribute("aria-disabled", ariaDisabled);
    if (enable) {
      this.elms.submit_btn.removeAttribute("disabled");
    } else {
      this.elms.submit_btn.setAttribute("disabled", true);
    }
  }

  handlePopoverNotification(response, elementToFocus) {
    if (this.quickViewDialog && !this.quickViewDialog.hasAttribute("hidden")) {
      this.quickViewDialog.closeModal();
      elementToFocus = this.quickViewDialog.opener;
    }
    if (this.quickBuyDialog && !this.quickBuyDialog.hasAttribute("hidden")) {
      this.quickBuyDialog.closeModal();
      elementToFocus = this.quickBuyDialog.opener;
    }

    const productQuantity = this.quickAddForm
      ? 1
      : this.elms.quantity_input_container.querySelector("input").value;
    this.cartNotification?.renderContents(
      response,
      true,
      elementToFocus,
      productQuantity
    );
    this.cartDrawerForm?.renderContents(response);
  }

  handleCartNotification(response, elementToFocus) {
    if (this.cartType === "drawer") {
      this.cartNotification?.renderContents(response, false);
      this.cartDrawerForm?.renderContents(response);
      this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage();
      this.cartDrawer?.openDrawer(elementToFocus);
      this.cartDrawer?.updateSwiperOpened();
    } else if (this.cartType === "page") {
      this.cartNotification?.renderContents(response, false);
      window.location.assign(window.routes.cart_url);
    }
  }

  handleDoNothingNotification(response, elementToFocus) {
    this.cartNotification?.renderContents(response, false, elementToFocus);
    this.cartDrawerForm?.renderContents(response);
    if (this.quickViewDialog && !this.quickViewDialog.hasAttribute("hidden")) {
      this.quickViewDialog.closeModal();
    }
    if (this.quickBuyDialog && !this.quickBuyDialog.hasAttribute("hidden")) {
      this.quickBuyDialog.closeModal();
    }
  }

  closeDialogAndOpenDrawer(dialog) {
    if (dialog && !dialog.hasAttribute("hidden")) {
      dialog.closeModal();
      dialog
        .animationsComplete()
        .then(() => {
          this.cartDrawer.openDrawer(dialog.opener);
          this.cartDrawer?.updateSwiperOpened();
        });
      return true;
    }
    return false;
  }

  hideErrorMessage() {
    this.elms.error_wrapper.toggleAttribute("hidden", true);
  }
  handleErrorMessage(errorMessage = false, message = "") {
    if (errorMessage) {
      const quantityMessage = BUTHelper.qsa(".js-max-quantity-message");
      quantityMessage.forEach((e) => e.classList.add("d-none-important"));
      if (typeof errorMessage == "string") {
        if (this.elms.error_wrapper && this.elms.error_message) {
          this.elms.error_wrapper?.toggleAttribute("hidden", !errorMessage);
          this.elms.error_message.textContent = errorMessage;
        }
      }

      if (this.cardRecipientForm && typeof errorMessage == "object") {
        this.cardRecipientForm.handleErrorMessage(errorMessage, message);
      }
    }
  }

  checkCartDrawerState() {
    const updateCartDrawerState = () => {
      if (this.cartDrawer || Shopify.designMode === true) {
        this.cartDrawer.setAttribute("data-state", "visible");
      } else {
        this.cartDrawer.setAttribute("data-state", "hidden");
      }
    };
    document.addEventListener("DOMContentLoaded", updateCartDrawerState);
  }
}
customElements.define("but-prd-frm", BUTProductForm);

class BUTProductMediaItemDeferredVideo extends BUTCustomComponent {
  /**
   * Constructor
   */
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.sectionID = this.dataset.sectionId;
    this.itemDeferredVideoImageElem = this.$(
      ".js-product-media-item-deferred-video-image"
    );
    this.idVideo = this.dataset.idVideo;
    this.eleVideo = `butVideo-${this.sectionID}-${this.idVideo}`;
    this.typeVideo = this.$(".js-media-item")?.dataset.type;
    this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this);
    this.onPlayerPlay = this.onPlayerPlay.bind(this);
    if (this.itemDeferredVideoImageElem) {
      this.itemDeferredVideoImageElem.addEventListener(
        "click",
        this.handlePlayVideo.bind(this)
      );
    }
  }

  handlePlayVideo() {
    this.loadContent();
    const video = this.querySelector(".js-media-item-video");
    if (video) {
      video.addEventListener("play", () => {
        this.pauseAllVideo(video);
        video.play();
      });
    }
  }

  onYouTubeIframeAPIReady(isVideoInZoomModal) {
    this.youtubeId = this.eleVideo;
    if (isVideoInZoomModal == true) {
      this.youtubeId = `${this.eleVideo}-videoInZoomModal`;
    }

    if (
      typeof YT !== "undefined" &&
      typeof YT.Player !== "undefined" &&
      !this.player
    ) {
      try {
        this.player = new YT.Player(this.youtubeId, {
          videoId: this.idVideo,
          playerVars: {
            playsinline: 1,
          },
          events: {
            onReady: this.onPlayerYTReady,
            onStateChange: this.onPlayerStateYTChange,
          },
        });
      } catch (error) {
        console.error("Error when creating YouTube player:", error);
      }
    } else {
      if (this.player) return;
      let tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      tag.id = "but-iframe-api";
      tag.onload = () => {
        this.onYouTubeIframeAPIReady(isVideoInZoomModal);
      };
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  onVimeoIframeAPIReady(isVideoInZoomModal) {
    this.vimeoId = this.eleVideo;
    if (isVideoInZoomModal == true) {
      this.vimeoId = `${this.eleVideo}-videoInZoomModal`;
    }
    if (typeof Vimeo !== "undefined" && typeof Vimeo.Player !== "undefined") {
      try {
        const options = {
          id: this.idVideo,
          autoplay: 1,
        };

        this.playerVimeo = new Vimeo.Player(this.vimeoId, options);
        this.playerVimeo.on("play", () => {
          this.pauseAllVideo(this.playerVimeo);
        });
      } catch (error) {
        console.error("Error when creating Vimeo player:", error);
      }
    } else {
      let tag = document.createElement("script");
      tag.src = "https://player.vimeo.com/api/player.js";
      tag.onload = () => {
        this.onVimeoIframeAPIReady(isVideoInZoomModal);
      };
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  onPlayerYTReady = () => {
    // this.pauseAllVideo(this.player);
    this.player.playVideo();
  };

  onPlayerStateYTChange = (event) => {
    if (event.data == 1) {
      this.onPlayerPlay();
    }
  };

  onPlayerPlay = () => {
    this.pauseAllVideo(this.player);
  };

  loadContent(isVideoInZoomModal) {
    if (!this.getAttribute("loaded")) {
      if (this.$("template")) {
        let template =
          this.$("template").content.firstElementChild.cloneNode(true);
        this.appendChild(template);
        this.isLoaded(true);
        this.itemDeferredVideoImageElem &&
          this.itemDeferredVideoImageElem.remove();
      } else {
        this.itemDeferredVideoImageElem?.classList.add("d-none");
        this.$(".js-media-item").classList.add("d-flex");

        if (this.typeVideo == "youtube") {
          this.onYouTubeIframeAPIReady(isVideoInZoomModal);
        } else {
          this.onVimeoIframeAPIReady(isVideoInZoomModal);
        }
      }
      return true;
    }
  }

  pauseAllVideo(currentVideo) {
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='youtube']"
    ).forEach((video) => {
      if (video.player && currentVideo !== video.player) {
        video.player?.pauseVideo();
      }
    });
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='vimeo'])"
    ).forEach((video) => {
      if (video.playerVimeo !== currentVideo) {
        video.playerVimeo?.pause();
      }
    });
    BUTHelper.qsa(".js-media-item-video").forEach((video) => {
      if (video !== currentVideo) {
        video.pause();
      }
    });
  }

  isLoaded(loaded) {
    if (loaded) {
      this.setAttribute("loaded", true);
    } else {
      this.removeAttribute("loaded");
    }
  }
}

customElements.define(
  "but-prd-media-itm-deferred-video",
  BUTProductMediaItemDeferredVideo
);

class BUTProductMediaItemModel extends BUTCustomComponent {
  constructor() {
    super();
    // this.$ = this.querySelector.bind(this);
    this.btnIcon3d = this.parentElement.querySelector(".js-btn-icon-3d");
    this.itemModelImageElem = this.$(".js-product-media-item-model-image");
    const elementsToTriggerLoad = [this.itemModelImageElem, this.btnIcon3d];
    elementsToTriggerLoad?.forEach((element) => {
      element?.addEventListener("click", () => {
        this.pauseAllMedia();
        this.loadContent();
      });
    });
  }

  pauseAllMedia() {
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='youtube']"
    ).forEach((video) => {
      video.player?.pauseVideo();
    });
    BUTHelper.qsa(
      ".js-product-media-deferred-video:has([data-type='vimeo'])"
    ).forEach((video) => {
      video.playerVimeo?.pause();
    });
    BUTHelper.qsa(".js-media-item-video").forEach((video) => {
      video.pause();
    });
    BUTHelper.qsa("but-prd-media-itm-model").forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  loadModelViewerUICss() {
    if (!BUTHelper.qs("#model-viewer-ui")) {
      let productModelCssFile = document.createElement("link");
      productModelCssFile.setAttribute(
        "href",
        `https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css`
      );
      // productModelCssFile.setAttribute("data-css-id", "model-viewer-ui");
      productModelCssFile.setAttribute("rel", "stylesheet");
      productModelCssFile.setAttribute("media", "all");
      productModelCssFile.setAttribute("id", "model-viewer-ui");
      document.getElementsByTagName("head")[0].appendChild(productModelCssFile);
    }
  }

  loadContent() {
    this.btnIcon3d?.classList.add("d-none-important");
    if (this.getAttribute("loaded")) return;

    let content = document.createElement("div");
    content.appendChild(
      this.$("template").content.firstElementChild.cloneNode(true)
    );

    this.setAttribute("loaded", true);

    this.itemModelImageElem && this.itemModelImageElem.remove();
    this.appendChild(content.querySelector("model-viewer")).focus();
    this.loadModelViewerUICss();
    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(this.$("model-viewer"));
  }
}

customElements.define("but-prd-media-itm-model", BUTProductMediaItemModel);

window.BUTProductMediaItemModel = {
  isMouseenter: false,
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () =>
        this.setupShopifyXR()
      );
      return;
    }

    BUTHelper.qsa('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

if (Shopify.designMode) {
  BUTHelper.qsa("[data-shopify-xr-hidden]").forEach((element) =>
    element.classList.add("hidden")
  );
  if (window.BUTProductMediaItemModel)
    window.BUTProductMediaItemModel.loadShopifyXR();
} else {
  if (window.BUTProductMediaItemModel) {
    window.addEventListener(
      "scroll",
      function (event) {
        if (!window.BUTProductMediaItemModel.isMouseenter) {
          window.BUTProductMediaItemModel.loadShopifyXR();
        }
        window.BUTProductMediaItemModel.isMouseenter = true;
      },
      false
    );
    ["mouseenter", "touchstart", "mouseover"].forEach(function (e) {
      BUTHelper.qs("body").addEventListener(e, function (event) {
        if (!window.BUTProductMediaItemModel.isMouseenter) {
          window.BUTProductMediaItemModel.loadShopifyXR();
        }
        window.BUTProductMediaItemModel.isMouseenter = true;
      });
    });
  }
}

if (!customElements.get("but-pickup-avail")) {
  customElements.define(
    "but-pickup-avail",
    class BUTPickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.$ = this.querySelector.bind(this);

        this.errorHtml =
          this.$("template").content.firstElementChild.cloneNode(true);
        this.onClickRefreshListHandleEvent =
          this.onClickRefreshListHandleEvent.bind(this);

        this.sectionId = this.dataset.sectionId;

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = routes.root_url;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        let url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            let sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            let button = this.$("button");
            if (button)
              button.removeEventListener(
                "click",
                this.onClickRefreshListHandleEvent
              );
            this.renderError();
          });
      }

      onClickRefreshListHandleEvent(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.$("button").addEventListener(
          "click",
          this.onClickRefreshListHandleEvent
        );
      }

      renderPreview(sectionInnerHTML) {
        let drawer = sectionInnerHTML.querySelector(
          "#drawerPickupAvailability"
        );

        if (drawer) {
          drawer.id = `drawerPickupAvailability-${this.sectionId}`;
        }

        let preview = sectionInnerHTML.querySelector("but-pickup-avail-prwv");

        if (!preview) {
          this.innerHTML = "";
          this.removeAttribute("available");
          this.classList.remove("d-block");
          this.classList.add("d-none");
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute("available", "");
        this.classList.add("d-block");
        this.classList.remove("d-none");

        if (this.dataset.showExpectedPickupTime == "true") {
          drawer.classList.add("pickup_availability--show-pickup-time");
        }

        document.body.appendChild(drawer);

        let button = this.$("button");
        button &&
          button.addEventListener("click", (e) => {
            drawer.openDrawer(e.target);
            drawer.updateSwiperOpened();
          });
      }
    }
  );
}

class BUTDialog extends BUTDialogCore {
  constructor() {
    super();
  }
}
customElements.define("but-dialog", BUTDialog);

if (!customElements.get("but-gallery")) {
  class BUTGallery extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = BUTHelper.qs(`but-dialog#${this.dataset.galleryDialogId}`);
      this.slides = this.$$(".js-gallery-slide");
      this.totalSlides = this.slides.length;
      this.currentIndex = 1;
      this.$$(".js-gallery-btn-thumb").forEach((e) => {
        e.addEventListener("click", this.setActiveMedia.bind(this, e));
      });
      this.thumbCarousel = this.$("but-horiz-carousel");
      // Add slide navigation buttons
      this.prevBtn = this.$(".js-slideshow-prev-btn");
      this.nextBtn = this.$(".js-slideshow-next-btn");
    }

    init() {
      this.dialog.addEventListener("opening", (e) => {
        try {
          if (window.BUTProductMediaItemModel) {
            window.BUTProductMediaItemModel.loadShopifyXR();
          }
          this.$$(".js-gallery-thumb").forEach((el) => {
            if (
              el.dataset.mediaTargetId == e.detail.opener.dataset.dialogMediaId
            ) {
              el.classList.add("is-active-gallery-thumb");
              this.scrollToThumb(el.dataset.mediaTargetId);
              const activeSlide = this.$(`[data-media-id="${el.dataset.mediaTargetId}"]`);
              if (activeSlide) {
                this.playActiveVideo(activeSlide);
                this.playActiveModel(activeSlide);
                this.currentIndex = parseInt(activeSlide.dataset.itemIndex) || 1;
              }
              throw "done";
            }
          });
        } catch (e) {}
      });

      this.dialog.addEventListener("closing", (e) => {
        this.$$(".js-gallery-thumb").forEach((el) => {
          el.classList.remove("is-active-gallery-thumb");
        });
        // Pause all media when dialog closes
        this.pauseAllVideo();
      });
      // Bind slide navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener("click", (ev) => {
          ev.preventDefault();
          this.prevSlide();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener("click", (ev) => {
          ev.preventDefault();
          this.nextSlide();
        });
      }
    }

    scrollToThumb(thumbId) {
      let carouselItem = this.thumbCarousel.querySelector(
        `[data-media-target-id="${thumbId}"]`
      );

      if (carouselItem) {
        this.thumbCarousel.querySelector(".js-carousel-items").scrollTo({
          left: carouselItem.offsetLeft,
          behavior: "auto",
        });
      }
    }

    setActiveMedia(e) {
      let preActiveMedia = this.$("but-gallery-slide.is-active-gallery-slide");
      if (preActiveMedia) {
        let zoomElement = preActiveMedia.querySelector("but-zoom");
        zoomElement && zoomElement.reset();
      }

      let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);

      let activeZoom = activeMedia.querySelector("but-zoom");

      let activeThumb = e.closest("but-horiz-carousel-itm");

      this.$$(".js-gallery-slide").forEach((element) => {
        element.classList.remove("is-active-gallery-slide", "d-flex");
        element.classList.add("d-none");
      });

      this.$$(".js-gallery-thumb").forEach((element) => {
        element.classList.remove("is-active-gallery-thumb");
      });

      activeMedia.classList.add("is-active-gallery-slide", "d-flex");
      activeMedia.classList.remove("d-none");
      activeThumb.classList.add("is-active-gallery-thumb");

      this.playActiveVideo(activeMedia);

      this.playActiveModel(activeMedia);

      if (activeZoom) {
        activeZoom.init();
      }
      // Update current index
      this.currentIndex = parseInt(activeMedia.dataset.itemIndex) || 1;
    }

    prevSlide() {
      if (this.currentIndex > 1) {
        this.goToSlide(this.currentIndex - 1);
      }
    }

    nextSlide() {
      if (this.currentIndex < this.totalSlides) {
        this.goToSlide(this.currentIndex + 1);
      }
    }

    goToSlide(index) {
      // Hide current active slide
      const currentSlide = this.$(".js-gallery-slide.is-active-gallery-slide");
      if (currentSlide) {
        const zoomElement = currentSlide.querySelector("but-zoom");
        zoomElement && zoomElement.reset();
        currentSlide.classList.remove("is-active-gallery-slide", "d-flex");
        currentSlide.classList.add("d-none");
      }

      // Show new slide
      const newSlide = this.slides[index - 1];
      if (newSlide) {
        newSlide.classList.remove("d-none");
        newSlide.classList.add("is-active-gallery-slide", "d-flex");
        const zoomElement = newSlide.querySelector("but-zoom");
        zoomElement && zoomElement.init();
        this.currentIndex = index;
        // Handle video and model media state
        this.playActiveVideo(newSlide);
        this.playActiveModel(newSlide);
        // Update thumbnail carousel to show corresponding thumb
        this.updateThumbnailCarousel(index);
      }
    }

    updateThumbnailCarousel(slideIndex) {
      if (this.thumbCarousel) {
        const thumbItems = this.thumbCarousel.$$("but-horiz-carousel-itm");
        const targetThumb = thumbItems[slideIndex - 1];
        if (targetThumb) {
          // Remove active class from all thumbs
          thumbItems.forEach(thumb => {
            thumb.classList.remove("is-active-gallery-thumb");
          });
          // Add active class to current thumb
          targetThumb.classList.add("is-active-gallery-thumb");
          targetThumb.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
          });
        }
      }
    }

    pauseAllVideo() {
      BUTHelper.qsa(
        ".js-product-media-deferred-video:has([data-type='youtube']"
      ).forEach((video) => {
        video.player?.pauseVideo();
      });
      BUTHelper.qsa(
        ".js-product-media-deferred-video:has([data-type='vimeo'])"
      ).forEach((video) => {
        video.playerVimeo?.pause();
      });
      BUTHelper.qsa(".js-media-item-video").forEach((video) => {
        video.pause();
      });
    }

    playActiveVideo(activeItem) {
      this.pauseAllVideo();
      let deferredExternalVideo = activeItem.querySelector(
        ".js-product-media-deferred-video"
      );

      if (deferredExternalVideo) deferredExternalVideo.loadContent(true);
    }

    playActiveModel(activeItem) {
      let deferredExternalModel = activeItem.querySelector(
        ".js-product-media-deferred-model"
      );
      if (deferredExternalModel) {
        deferredExternalModel.loadContent();
      }
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }
  customElements.define("but-gallery", BUTGallery);
}

class BUTHorizontalCarousel extends BUTCustomComponent {
  constructor() {
    super();
    this.sectionID = this.dataset.sectionId;
    this.carousels = this.$$(".js-carousel-item");
    this.container = this.$(".js-carousel-items");
    this.totalItems = this.carousels.length;
    this.prevBtnElement = this.$(".js-carousel-prev-btn");
    this.nextBtnElement = this.$(".js-carousel-next-btn");
    this.currentElement = this.$(".js-carousel-counter-current");
    this.totalElement = this.$(".js-carousel-counter-total");
    this.paginationElement = this.$(".js-carousel-pagination");
    this.init();
    this.bindEventHandlers();
  }
  init() {
    this.itemsToShow = Array.from(this.carousels).filter(
      (element) => element.clientWidth > 0
    );
    if (this.itemsToShow.length < 2) {
      this.horizontalTogglePagination(false);
      return;
    } else {
      this.horizontalTogglePagination(true);
    }

    this.gutter =
      parseFloat(
        window
          .getComputedStyle(this.itemsToShow[1], null)
          .getPropertyValue("padding-left")
      ) +
      parseFloat(
        window
          .getComputedStyle(this.itemsToShow[1], null)
          .getPropertyValue("padding-right")
      );

    this.itemOffset =
      this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft;
    this.itemsPerPage = Math.floor(
      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) /
        this.itemOffset
    );
    // this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1;
    this.updateCarousel();
  }

  horizontalTogglePagination(flag) {
    if (flag) {
      this.paginationElement?.classList.remove("d-none-important");
      this.paginationElement?.classList.add("d-flex");
    } else {
      this.paginationElement?.classList.remove("d-flex");
      this.paginationElement?.classList.add("d-none-important");
    }
  }

  updateCarousel() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.container.scrollLeft / this.itemOffset) + 1;
    if (this.currentPage > 0 && this.totalPages > 0) {
      if (this.totalElement) {
        this.totalElement.textContent = this.totalPages;
      }
      if (this.currentElement) {
        this.currentElement.innerHTML =
          this.currentPage +
          `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`;
      }
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("itemChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.itemsToShow[this.currentPage - 1],
            container: this,
          },
        })
      );
    }
    if (
      this.isItemVisible(this.itemsToShow[0]) &&
      this.container.scrollLeft === 0
    ) {
      this.prevBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.prevBtnElement.removeAttribute("disabled");
    }
    if (this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) {
      this.nextBtnElement.setAttribute("disabled", "disabled");
    } else {
      this.nextBtnElement.removeAttribute("disabled");
    }
  }

  isItemVisible(element, offset = 0) {
    const lastVisibleItem =
      this.container.clientWidth + this.container.scrollLeft - offset + 1;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleItem &&
      element.offsetLeft >= this.container.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    let step = 1;
    let gutter = 0;
    const mediaQuery = window.matchMedia("(min-width: 769px)");
    if (mediaQuery.matches) {
      step = event.currentTarget.dataset.step;
    }
    if (
      this.container.scrollLeft == 0 ||
      this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
    ) {
      gutter = this.gutter;
    }
    this.itemScrollPosition =
      event.currentTarget.name === "next"
        ? this.container.scrollLeft - gutter + step * this.itemOffset
        : this.container.scrollLeft + gutter - step * this.itemOffset;
    window.requestAnimationFrame(() =>
      this.container.scrollTo({
        left: this.itemScrollPosition,
        behavior: "smooth",
      })
    );
  }
  bindEventHandlers() {
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.container);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.init();
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(this);

    if (this.prevBtnElement) {
      this.prevBtnElement.addEventListener(
        "click",
        this.onButtonClick.bind(this)
      );
    }
    if (this.nextBtnElement) {
      this.nextBtnElement.addEventListener(
        "click",
        this.onButtonClick.bind(this)
      );
    }
    this.container.addEventListener(
      "scroll",
      BUTHelper.debounce(this.updateCarousel.bind(this), 100)
    );
  }
}
customElements.define("but-horiz-carousel", BUTHorizontalCarousel);

if (!customElements.get("but-gallery-slides")) {
  class BUTGallerySlides extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.gallery = this.closest("but-gallery");
      this.dialog = BUTHelper.qs(
        `but-dialog#${this.gallery.dataset.galleryDialogId}`
      );
      this.slides = this.$$(".js-gallery-slide");
      this.totalSlides = this.slides.length;
      this.prevBtnElement = this.$(".js-slide-prev-btn");
      this.nextBtnElement = this.$(".js-slide-next-btn");
      this.currentSlideElement = this.$(".js-slide-current");
      this.totalElement = this.$(".js-slide-total");
      this.paginationElement = this.$(".js-slide-pagination");
      this.currentIndex = 1;
    }

    init() {
      this.dialog.addEventListener("opening", (e) => {
        try {
          this.slides.forEach((el) => {
            el.classList.add("d-none");
            el.classList.remove("is-active-gallery-slide", "d-flex");
            if (el.dataset.mediaId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.remove("d-none");
              el.classList.add("is-active-gallery-slide", "d-flex");
              let zoomElement = el.querySelector("but-zoom");
              zoomElement && zoomElement.init();
              this.currentIndex = el.dataset.itemIndex;
              throw "done";
            }
          });
        } catch (e) {}
      });
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }

  customElements.define("but-gallery-slides", BUTGallerySlides);
}

if (!customElements.get("but-zoom")) {
  class BUTZoom extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.image = this.$(".js-zoom-item");

      this.container = BUTHelper.qs(`#${this.dataset.containerId}`);
      this.image_natural_dimension = {};
      this.container_dimension = {};
      this.rendered_aspect_ratio = {};
      this.image_dimension = {};
      this.is_able_to_zoom = true;

      this.bindEventHandlers();
    }

    init() {
      // this.getImageNaturalDimension();
      this.getImageDimension();
      this.getContainerDimension();
      let tmpSrc = this.image.src;
      let tmpSrcset = this.image.srcset;
      this.image.scr = tmpSrc;
      this.image.srcset = tmpSrcset;
      //this.calculateRenderedAspectRatio();

      // let isAbleToZoom = this.ableToZoom();
      // if (!isAbleToZoom) {
      //   this.image.style.cursor = "default";
      //   this.is_able_to_zoom = false;
      // }
      // this.bindEventHandlers();
    }

    ableToZoom() {
      if (
        this.rendered_aspect_ratio.container <=
          this.rendered_aspect_ratio.image ||
        (this.image_natural_dimension.width <= this.container_dimension.width &&
          this.image_natural_dimension.height <=
            this.container_dimension.height)
      )
        return false;

      return true;
    }

    bindEventHandlers() {
      this.image.addEventListener("click", (e) => {
        e.preventDefault();
        // let offsetX = 0;
        // let offsetY = 0;
        // e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
        // e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);

        let isZoomed = this.image.hasAttribute("zoomed");

        if (!isZoomed) {
          this.zoomIn();
        } else {
          this.zoomOut();
        }
      });
    }

    zoomIn() {
      const mediaQuery = window.matchMedia("(max-width: 459px)");
      this.image.style.height = "auto";
      this.image.style.objectFit = "unset";
      this.image.setAttribute("zoomed", true);
      this.image.style.cursor = "zoom-out";
      if (mediaQuery.matches) {
        this.image.style.width = "150%";
        this.image.style.maxWidth = "unset";
      } else {
        this.image.style.width = "100%";
      }

      if (this.image.offsetHeight <= this.container_dimension.height) {
        this.classList.add("d-flex", "fd-column", "center-xs");
      }
      this.container.classList.add("o-scroll");
      this.container.scrollTo({
        top: this.container.scrollHeight / 2 - this.container.offsetHeight / 2,
        behavior: "auto",
      });

      if (mediaQuery.matches) {
        this.container.scrollTo({
          left: this.container.scrollWidth / 2 - this.container.offsetWidth / 2,
          behavior: "auto",
        });
      }
    }

    zoomOut() {
      this.image.style.width = "100%";
      this.image.style.height = "100%";
      this.image.style.objectFit = "contain";
      this.image.removeAttribute("zoomed");
      this.image.style.cursor = "zoom-in";

      this.classList.remove("d-flex", "fd-column", "center-xs");
      this.container.classList.remove("o-scroll");
      this.image.style.maxWidth = null;
    }

    reset() {
      this.zoomOut();
    }

    calculateRenderedAspectRatio() {
      this.rendered_aspect_ratio = {
        image:
          this.image_natural_dimension.width /
          this.image_natural_dimension.height,
        container:
          this.container_dimension.width / this.container_dimension.height,
      };
    }

    getImageNaturalDimension() {
      this.image_natural_dimension = {
        width: parseInt(this.image.getAttribute("width")),
        height: parseInt(this.image.getAttribute("height")),
      };
    }

    getImageDimension() {
      this.image_dimension = {
        width: this.image.offsetWidth,
        height: this.image.offsetHeight,
      };
    }

    getContainerDimension() {
      this.container_dimension = {
        width: this.container.offsetWidth,
        height: this.container.offsetHeight,
      };
    }
  }
  customElements.define("but-zoom", BUTZoom);
}

if (!customElements.get("but-gallery-slide")) {
  class BUTGallerySlide extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = BUTHelper.qs(`but-dialog#${this.dataset.galleryDialogId}`);
      this.mediaId = this.dataset.mediaId;
      this.zoomElement = this.$("but-zoom");
    }

    init() {
      this.dialog.addEventListener("closing", (e) => {
        this.classList.add("d-none");
        this.classList.remove("is-active-gallery-slide", "d-flex");
        this.zoomElement && this.zoomElement.reset();
        this.pauseAllVideo();
      });
    }

    pauseAllVideo() {
      BUTHelper.qsa(
        ".js-product-media-deferred-video:has([data-type='youtube']"
      ).forEach((video) => {
        video.player?.pauseVideo();
      });
      BUTHelper.qsa(
        ".js-product-media-deferred-video:has([data-type='vimeo'])"
      ).forEach((video) => {
        video.playerVimeo?.pause();
      });
      BUTHelper.qsa(".js-media-item-video").forEach((video) => {
        video.pause();
      });
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }

  customElements.define("but-gallery-slide", BUTGallerySlide);
}

class BUTDrawerPickup extends BUTCoreDrawer {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.mainDrawer = this.$(".js-drawer-wrapper");
    this.mainProduct = BUTHelper.qs(".js-main-product");
    if (this.mainProduct && this.mainProduct.dataset.color) {
      this.mainDrawer.classList.add(this.mainProduct.dataset.color);
    }
  }
}
customElements.define("but-drwr-pickup", BUTDrawerPickup);
